import React, { useState, useEffect, useCallback, useRef } from 'react';
import './Formulario.css';
import LoadingOverlay from '../components/LoadingOverlay';
import { apiCallAuth, getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';
import BotaoVoltarTopo from '../components/BotaoVoltarTopo';

export default function FormularioVendaProduto({ 
  produtoSelecionado, 
  vendaEdicao = null,
  onSalvar, 
  onCancelar,
  clientes = [],
  vendedores = [],
  tiposPagamento = [],
  onAbrirPopupProdutos = null,
  vendaItems = [],
  onAdicionarItem = null,
  onAtualizarItem = null,
  onRemoverItem = null
}) {
  // suporte a múltiplos itens (carrinho)
  // props opcionais: vendaItems, onAdicionarItem, onAtualizarItem, onRemoverItem
  // (serão passadas pelo container quando necessário)
  // Note: valores iniciais e callbacks serão injetados pelo pai
  const [itemsProp, setItemsProp] = useState(vendaItems || []);
  const [items, setItems] = useState(vendaItems && vendaItems.length > 0 ? vendaItems.slice() : []);

  // Receber props dinamicamente (se o pai passar via props, acessar através arguments?)
  // Como o componente já recebe props via argumento, precisamos extrair dinamicamente.
  // Estados para lógica de pagamento (copiado do VendasDropdown)
  const [configuracoesPagamento, setConfiguracoesPagamento] = useState([]);
  const [configuracoesFiltradas, setConfiguracoesFiltradas] = useState([]);
  const [tipoPagamentoSelecionado, setTipoPagamentoSelecionado] = useState(null);
  const [configuracaoSelecionadaId, setConfiguracaoSelecionadaId] = useState(null);
  const [quantidadeParcelas, setQuantidadeParcelas] = useState(1);
  const [dataInicioVencimento, setDataInicioVencimento] = useState(() => new Date().toISOString().split('T')[0]);
  const [calculoPagamento, setCalculoPagamento] = useState(null);
  const [carregandoCalculo, setCarregandoCalculo] = useState(false);
  const [erroCalculo, setErroCalculo] = useState('');
  const [tipoJurosUI, setTipoJurosUI] = useState('');
  // Entrega relacionada (quando existir)
  const [entregaData, setEntregaData] = useState(null);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [uploadPreviews, setUploadPreviews] = useState([]);
  const [uploadingFotos, setUploadingFotos] = useState(false);
  // Dados do cartão (para pagamentos por cartão)
  const [numeroCartao, setNumeroCartao] = useState('');
  const [nomeTitular, setNomeTitular] = useState('');
  const [mesVencimento, setMesVencimento] = useState('');
  const [anoVencimento, setAnoVencimento] = useState('');
  const [codigoSeguranca, setCodigoSeguranca] = useState('');
  
  // Estados para Stripe Checkout (pagamento após aprovação)
  const [vendaAtual, setVendaAtual] = useState(vendaEdicao);
  const [processandoPagamento, setProcessandoPagamento] = useState(false);
  const [statusPagamentoVenda, setStatusPagamentoVenda] = useState(vendaEdicao?.statusPagamento || vendaEdicao?.StatusPagamento || null);
  const [globalLoading, setGlobalLoading] = useState(false);

  // Estados para popup de confirmação de pagamento
  const [showPopupPagamento, setShowPopupPagamento] = useState(false);
  const [processandoConfirmarPagamento, setProcessandoConfirmarPagamento] = useState(false);
  const [itensPopupPagamento, setItensPopupPagamento] = useState([]);
  const [totalPopupPagamento, setTotalPopupPagamento] = useState(0);

  // Estados para popup de compartilhar link de pagamento (copiar / whatsapp / email)
  const [showPopupCompartilharPagamento, setShowPopupCompartilharPagamento] = useState(false);
  const [linkPagamentoGerado, setLinkPagamentoGerado] = useState('');
  const [linkPagamentoCopiado, setLinkPagamentoCopiado] = useState(false);
  const [emailEnviandoPagamento, setEmailEnviandoPagamento] = useState(false);
  const [statusPopupPagamento, setStatusPopupPagamento] = useState(null);

  // ===== Cliente selecionado =====
  const [clienteSelecionadoId, setClienteSelecionadoId] = useState(vendaEdicao?.clineteId || '');
  const [clienteDropdownAberto, setClienteDropdownAberto] = useState(false);
  const [clienteBusca, setClienteBusca] = useState('');
  const clienteDropdownRef = useRef(null);

  // ===== Vendedor selecionado =====
  const [vendedorSelecionadoId, setVendedorSelecionadoId] = useState(vendaEdicao?.vendedorId ? String(vendaEdicao.vendedorId) : '');
  const [vendedorDropdownAberto, setVendedorDropdownAberto] = useState(false);
  const [vendedorBusca, setVendedorBusca] = useState('');
  const vendedorDropdownRef = useRef(null);

  // ===== Cancelar venda aprovada =====
  const [popupCancelarVenda, setPopupCancelarVenda] = useState(false);
  const [cancelandoVenda, setCancellandoVenda] = useState(false);

  // ===== Dados do Comprador (para NF-e) =====
  const [mostrarDadosComprador, setMostrarDadosComprador] = useState(false);
  const [compradorExistenteId, setCompradorExistenteId] = useState(null);
  const [dadosComprador, setDadosComprador] = useState({
    tipoDocumento: 'CPF',
    numeroDocumento: '',
    nomeRazaoSocial: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    codigoMunicipioIBGE: '',
    nomeMunicipio: '',
    uf: '',
    cep: '',
    telefone: '',
    email: '',
    indicadorIE: '9',
    inscricaoEstadual: '',
    regimeTributario: 'SIMPLES',
    consumidorFinal: true,
    presencaComprador: '1'
  });
  // Função para fazer chamadas da API com fallback de URLs (mesmo padrão do VendasDropdown)
  const apiCall = async (endpoint, method = 'GET', data = null) => {
    const urls = [
      `${BASE_URL}/${endpoint}`
    ];
    let lastError = null;
    
    // Obter token de autenticação do localStorage
    const token = localStorage.getItem('authToken');

    for (const url of urls) {
      try {
        console.log(`🔄 Tentando ${method} em: ${url}`);
        const config = {
          method,
          headers: {
            'Content-Type': 'application/json',
          }
        };
        
        // Adicionar token de autenticação se disponível
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        
        if (data && (method === 'POST' || method === 'PUT')) {
          config.body = JSON.stringify(data);
        }

        const response = await fetch(url, config);

        // Se receber 401 e tiver token, tentar sem token (para endpoints AllowAnonymous)
        if (response.status === 401 && token) {
          console.log(`⚠️ Erro 401 com token, tentando sem autenticação...`);
          delete config.headers['Authorization'];
          const retryResponse = await fetch(url, config);
          if (retryResponse.ok || (retryResponse.status >= 200 && retryResponse.status < 300)) {
            console.log(`✅ SUCESSO sem token em: ${url}`);
            const contentType = retryResponse.headers.get('Content-Type') || '';
            if (contentType.includes('application/json')) {
              return await retryResponse.json();
            }
            return await retryResponse.text();
          } else {
            // Log detalhado do retryResponse quando falhar
            let retryBody = '';
            try {
              retryBody = await retryResponse.text();
            } catch (e) {
              retryBody = `<erro ao ler corpo: ${e.message}>`;
            }
            let retryJson = null;
            try { retryJson = JSON.parse(retryBody); } catch { retryJson = null; }
            console.error(`❌ Retry sem token falhou em: ${url} - Status: ${retryResponse.status}`, retryJson ?? retryBody);
          }
        }

        // Aceitar códigos de status de sucesso (200-299)
        if (response.ok || (response.status >= 200 && response.status < 300)) {
          console.log(`✅ SUCESSO em: ${url} - Status: ${response.status}`);

          // Para DELETE ou status 204 (No Content)
          if (method === 'DELETE' || response.status === 204) {
            return { success: true, status: response.status };
          }

          // Verificar se há conteúdo para fazer parse JSON
          const contentType = response.headers.get('Content-Type') || '';
          if (contentType.includes('application/json')) {
            try {
              const jsonData = await response.json();
              return jsonData;
            } catch (jsonError) {
              console.log(`⚠️ Erro ao parsear JSON, mas operação foi bem-sucedida`);
              return { success: true, status: response.status };
            }
          } else {
            // Resposta sem JSON
            const textData = await response.text();
            return { success: true, status: response.status, data: textData };
          }
        }

        // Em caso de falha, logar status e corpo da resposta para diagnóstico
        let body = '';
        try {
          body = await response.text();
        } catch (e) {
          body = `<erro ao ler corpo: ${e.message}>`;
        }
        let parsed = null;
        try { parsed = JSON.parse(body); } catch { parsed = null; }
        console.error(`❌ Falha em: ${url} - Status: ${response.status}`, parsed ?? body);

        const error = new Error(
          parsed?.mensagem ||
          parsed?.error ||
          parsed?.message ||
          parsed?.erro ||
          parsed?.detalhes ||
          `Erro ${response.status} em ${method} ${endpoint}`
        );
        error.status = response.status;
        error.code = parsed?.code || null;
        error.payload = parsed || body;
        lastError = error;
      } catch (error) {
        console.log(`❌ Erro em: ${url} - ${error.message}`);
        lastError = error;
      }
    }

    if (lastError) throw lastError;
    throw new Error(`Nenhuma URL da API funcionou para ${method} ${endpoint}. Verifique se o backend está rodando.`);
  };

  // Função para calcular o valor total em tempo real
  const calcularTotal = useCallback(() => {
    try {
      const form = document.querySelector('form[data-calculo="vendaProduto"]');
      if (!form) return;

      const desconto = parseFloat(form.desconto?.value || 0);
      const impostos = 0;

      let total = 0;
      if (items && items.length > 0) {
        for (const it of items) {
          const p = parseFloat(it.precoUnitario || 0);
          const q = parseFloat(it.quantidade || 0) || 0;
          total += p * q;
        }
      } else {
        // fallback para comportamento antigo (produto único)
        const preco = parseFloat(produtoSelecionado?.preco || 0);
        const quantidade = parseInt(form.quantidade?.value || 1);
        total = preco * quantidade;
      }

      const valorComDesconto = total - desconto;
      const valorFinal = valorComDesconto + impostos;

      const elementoValor = document.getElementById('valorCalculado');
      if (elementoValor) {
        elementoValor.textContent = valorFinal.toFixed(2).replace('.', ',');
      }
    } catch (error) {
      console.error('Erro no cálculo:', error);
    }
  }, [produtoSelecionado, items]);

  // Calcular valor inicial após renderização
  useEffect(() => {
    if (produtoSelecionado) {
      setTimeout(() => {
        calcularTotal();
      }, 100);
    }
  }, [produtoSelecionado, calcularTotal]);

  // Sincronizar items internos com prop vendaItems quando fornecido pelo pai
  useEffect(() => {
    if (Array.isArray(vendaItems)) {
      setItems(vendaItems.slice());
    } else {
      setItems([]);
    }
  }, [vendaItems]);

  // Debug dos tipos de pagamento
  useEffect(() => {
    if (tiposPagamento.length > 0) {
      console.log('✅ Tipos de pagamento carregados:', tiposPagamento.length);
    }
  }, [tiposPagamento]);

  // Carregar configurações de pagamento
  useEffect(() => {
    fetchConfiguracoesPagamento();
  }, []);

  // Quando as configurações de pagamento forem carregadas (ou o tipo de pagamento mudar), refiltrar
  useEffect(() => {
    if (configuracoesPagamento && configuracoesPagamento.length > 0 && tipoPagamentoSelecionado) {
      filtrarConfiguracoesPorTipo(tipoPagamentoSelecionado);
    }
    // Se configuracoesPagamento carregar e já houver uma venda em edição com configuracao definida, tentar selecionar
    if (configuracoesPagamento && configuracoesPagamento.length > 0 && vendaEdicao && (vendaEdicao.configuracaoPagamentoId || vendaEdicao.ConfiguracaoPagamentoId)) {
      const cfgId = vendaEdicao.configuracaoPagamentoId || vendaEdicao.ConfiguracaoPagamentoId;
      // se o tipo de pagamento da venda bate com o selecionado, aplicar
      if (!configuracaoSelecionadaId) {
        setConfiguracaoSelecionadaId(cfgId);
        // também atualizar o campo do formulário se existir
        setTimeout(() => {
          const form = document.querySelector('form[data-calculo="vendaProduto"]');
          if (form && form.configuracaoPagamentoId) form.configuracaoPagamentoId.value = cfgId;
        }, 50);
      }
    }
  }, [configuracoesPagamento, tipoPagamentoSelecionado, vendaEdicao]);

  // Preencher campos automaticamente quando em modo de edição
  useEffect(() => {
    if (vendaEdicao) {
      console.log('🔧 Preenchendo formulário com dados da venda:', vendaEdicao);
      
      // Aguardar um momento para garantir que o DOM foi renderizado
      setTimeout(() => {
        const form = document.querySelector('form[data-calculo="vendaProduto"]');
        if (!form) return;
        
        try {
          // Preencher campos do formulário
          if (form.quantidade) form.quantidade.value = vendaEdicao.quantidadeProduto || 1;
          // clienteId é controlado via state (clienteSelecionadoId)
          if (vendaEdicao.clineteId) {
            setClienteSelecionadoId(String(vendaEdicao.clineteId));
          } else {
            setClienteSelecionadoId('outros');
          }
          setVendedorSelecionadoId(vendaEdicao.vendedorId ? String(vendaEdicao.vendedorId) : '');
          if (form.dataVenda) form.dataVenda.value = vendaEdicao.dataVenda ? vendaEdicao.dataVenda.split('T')[0] : '';
          if (form.statusVenda) form.statusVenda.value = vendaEdicao.statusVenda || 'Pendente';
          if (form.desconto) form.desconto.value = vendaEdicao.desconto || 0;
          if (form.dataEntrega) form.dataEntrega.value = vendaEdicao.dataEntregaProgramada ? vendaEdicao.dataEntregaProgramada.split('T')[0] : '';
          if (form.notas) form.notas.value = vendaEdicao.notas || '';
          
          // Configurar tipo de pagamento se disponível
          if (vendaEdicao.tipoPagamentoId) {
            const tipoPagamentoId = vendaEdicao.tipoPagamentoId;
            setTipoPagamentoSelecionado(tipoPagamentoId);
            filtrarConfiguracoesPorTipo(tipoPagamentoId);
            
            if (form.tipoPagamentoId) {
              form.tipoPagamentoId.value = tipoPagamentoId;
            }
          }
          
          // Configurar configuração de pagamento se disponível
          if (vendaEdicao.configuracaoPagamentoId) {
            const configuracaoId = vendaEdicao.configuracaoPagamentoId;
            setConfiguracaoSelecionadaId(configuracaoId);
            
            if (form.configuracaoPagamentoId) {
              form.configuracaoPagamentoId.value = configuracaoId;
            }
          }
          
          // Configurar quantidade de parcelas se disponível
          if (vendaEdicao.quantidadeParcelas) {
            const qtdParcelas = vendaEdicao.quantidadeParcelas;
            setQuantidadeParcelas(qtdParcelas);
            
            if (form.quantidadeParcelas) {
              form.quantidadeParcelas.value = qtdParcelas;
            }
          }
          
          // Configurar data de início de vencimento se disponível
          if (vendaEdicao.dataInicioVencimento) {
            const dataInicio = vendaEdicao.dataInicioVencimento;
            const dataFormatada = dataInicio.split('T')[0];
            setDataInicioVencimento(dataFormatada);
            
            if (form.dataInicioVencimento) {
              form.dataInicioVencimento.value = dataFormatada;
            }
          }
          
          // Recalcular totais
          calcularTotal();

          // Preencher dados do cartão se existirem na venda em edição
          try {
            const dadosCartao = vendaEdicao.DadosCartao || vendaEdicao.dadosCartao || vendaEdicao.DadosPagamento || vendaEdicao.dadosPagamento || null;
            if (dadosCartao) {
              setNumeroCartao(dadosCartao.NumeroCartao ?? dadosCartao.numeroCartao ?? dadosCartao.Numero ?? '');
              setNomeTitular(dadosCartao.NomeTitular ?? dadosCartao.nomeTitular ?? dadosCartao.Nome ?? '');
              setMesVencimento(dadosCartao.MesVencimento ?? dadosCartao.mesVencimento ?? '');
              setAnoVencimento(dadosCartao.AnoVencimento ?? dadosCartao.anoVencimento ?? '');
              setCodigoSeguranca(dadosCartao.CodigoSeguranca ?? dadosCartao.codigoSeguranca ?? '');
            }
          } catch (err) {
            console.warn('Erro ao preencher dados do cartão:', err);
          }
          
          console.log('✅ Formulário preenchido com sucesso');
          
        } catch (error) {
          console.error('❌ Erro ao preencher formulário:', error);
        }
      }, 200);
    }
  }, [vendaEdicao, calcularTotal]);

  // Helper simples para detectar se um tipo de pagamento é cartão (procura palavras chave nas descrições)
  const isCardPaymentType = (tipoIdOrValue) => {
    const tipoId = tipoIdOrValue == null ? tipoPagamentoSelecionado : tipoIdOrValue;
    if (!tipoId) return false;
    const tipo = tiposPagamento.find(t => (t.id || t.Id) === (parseInt(tipoId) || tipoId));
    const txt = (tipo && (tipo.descricaoPagamento || tipo.DescricaoPagamento || tipo.nome || tipo.Nome || tipo.descricao || tipo.Descricao || '')).toString().toLowerCase();
    return txt.includes('cart') || txt.includes('card') || txt.includes('cartão');
  };

  // ==============================================
  // STRIPE CHECKOUT - Realizar pagamento
  // ==============================================
  const handleRealizarPagamento = async () => {
    const idVenda = vendaAtual?.id || vendaAtual?.Id || vendaEdicao?.id || vendaEdicao?.Id;
    if (!idVenda) {
      alert('ID da venda não encontrado.');
      return;
    }

    setProcessandoPagamento(true);
    try {
      console.log('🔄 Criando checkout Stripe para venda:', idVenda);
      const result = await apiCall(`VendaPagamento/create-checkout/${idVenda}`, 'POST');
      
      if (result && result.checkoutUrl) {
        console.log('✅ Checkout Stripe criado:', result.checkoutUrl);
        // Abrir popup para compartilhar o link (copiar / whatsapp / email) em vez de abrir direto
        setLinkPagamentoGerado(result.checkoutUrl);
        setLinkPagamentoCopiado(false);
        setShowPopupCompartilharPagamento(true);
      } else {
        const errorMsg = result?.error || result?.message || 'Erro ao criar checkout';
        alert('Erro ao criar checkout: ' + errorMsg);
        console.error('❌ Erro no checkout:', result);
      }
    } catch (error) {
      console.error('❌ Erro ao criar checkout Stripe:', error);
      alert('Erro ao criar checkout: ' + (error.message || 'Erro desconhecido'));
    } finally {
      setProcessandoPagamento(false);
    }
  };

  // Abrir popup de confirmação de pagamento
  const handleAbrirPopupPagamento = () => {
    const form = document.querySelector('form[data-calculo="vendaProduto"]');
    const desconto = parseFloat(form?.desconto?.value || 0);
    const impostos = parseFloat(form?.impostos?.value || 0);
    let itensList = [];
    let total = 0;

    if (items && items.length > 0) {
      let base = 0;
      itensList = items.map(it => {
        const preco = parseFloat(it.precoUnitario || 0);
        const qtd = parseInt(it.quantidade || 1);
        const subtotal = preco * qtd;
        base += subtotal;
        return { nome: it.nome || `Produto ${it.produtoId}`, quantidade: qtd, precoUnitario: preco, subtotal };
      });
      total = base - desconto + impostos;
    } else if (produtoSelecionado) {
      const qtd = parseInt(form?.quantidade?.value || 1);
      const preco = parseFloat(produtoSelecionado.preco || 0);
      const subtotal = preco * qtd;
      total = subtotal - desconto + impostos;
      itensList = [{ nome: produtoSelecionado.nome, quantidade: qtd, precoUnitario: preco, subtotal }];
    }

    setItensPopupPagamento(itensList);
    setTotalPopupPagamento(total);
    setShowPopupPagamento(true);
  };

  // Confirmar e realizar pagamento: auto-salva a venda e gera checkout Stripe
  const handleConfirmarEPagar = async () => {
    const idVenda = vendaAtual?.id || vendaAtual?.Id || vendaEdicao?.id || vendaEdicao?.Id;
    if (!idVenda) {
      alert('ID da venda não encontrado. Salve a venda primeiro.');
      return;
    }

    setShowPopupPagamento(false);
    setProcessandoConfirmarPagamento(true);
    setGlobalLoading(true);

    try {
      // 1. Coletar dados do formulário e auto-salvar
      const form = document.querySelector('form[data-calculo="vendaProduto"]');
      if (!form) throw new Error('Formulário não encontrado');

      const formData = new FormData(form);
      const quantidade = parseInt(formData.get('quantidade')) || 1;
      const desconto = parseFloat(formData.get('desconto')) || 0;
      const impostos = parseFloat(formData.get('impostos')) || 0;

      let valorBase = 0;
      if (items && items.length > 0) {
        valorBase = items.reduce((acc, item) => {
          return acc + (parseFloat(item.precoUnitario || 0) * (parseInt(item.quantidade || 1)));
        }, 0);
      } else {
        valorBase = quantidade * parseFloat(produtoSelecionado?.preco || 0);
      }

      const valorComDescontoImpostos = valorBase - desconto + impostos;

      let tipoJurosId = 2;
      let valorJurosFinal = 0;
      const cfgPag = configuracoesPagamento.find(c => (c.id || c.Id) === configuracaoSelecionadaId) || {};
      const descJuros = (cfgPag.configuracaoJurosDescricao || cfgPag.ConfiguracaoJurosDescricao || '').toUpperCase();
      const temJurosCfg = descJuros.includes('COM');
      if (tipoJurosUI && temJurosCfg) {
        const tipo = tipoJurosUI.toUpperCase();
        if (tipo === 'ABSOLUTO') { tipoJurosId = 2; valorJurosFinal = calculoPagamento?.valorJuros ?? cfgPag.valorJuros ?? 0; }
        else if (tipo === 'PERCENTUAL') { tipoJurosId = 3; valorJurosFinal = calculoPagamento?.valorJuros ?? cfgPag.valorJuros ?? 0; }
      }

      const vendaDataSave = {
        Id: idVenda,
        ProdutoId: items && items.length > 0 ? null : (produtoSelecionado?.id || null),
        QuantidadeProduto: items && items.length > 0 ? null : quantidade,
        TipoVendaId: 1,
        TipoVendaNatureza: 'produto',
        ValorVenda: valorComDescontoImpostos,
        Desconto: desconto,
        Impostos: impostos,
        ConfiguracaoPagamentoId: configuracaoSelecionadaId || null,
        QuantidadeParcelas: calculoPagamento?.quantidadeParcelas || parseInt(formData.get('quantidadeParcelas')) || 1,
        ValorParcela: calculoPagamento?.valorParcela || null,
        ValorJuros: valorJurosFinal,
        ValorFinal: calculoPagamento?.valorFinal || valorComDescontoImpostos,
        ValorOriginal: valorBase,
        ClineteId: clienteSelecionadoId && clienteSelecionadoId !== 'outros' ? parseInt(clienteSelecionadoId) : null,
        DataVenda: formData.get('dataVenda') || new Date().toISOString().split('T')[0],
        StatusVenda: 'Aprovada', // forçar Aprovada para que o checkout Stripe seja gerado
        VendedorId: vendedorSelecionadoId ? parseInt(vendedorSelecionadoId) : null,
        TipoPagamentoId: tipoPagamentoSelecionado || parseInt(formData.get('tipoPagamentoId')) || null,
        StatusEntrega: vendaEdicao?.statusEntrega || 'Pendente',
        DataEntregaProgramada: formData.get('dataEntrega') ? new Date(formData.get('dataEntrega')).toISOString() : null,
        Notas: formData.get('notas') || vendaEdicao?.notas || '',
        DescricaoOrcamento: vendaEdicao?.descricaoOrcamento || `Venda de produto`,
        TipoJurosId: tipoJurosId,
      };

      console.log('💾 [Pagamento] Auto-salvando venda antes do checkout:', vendaDataSave);
      await apiCall(`Vendas/${idVenda}`, 'PUT', vendaDataSave);
      console.log('✅ [Pagamento] Venda auto-salva com sucesso');

      // 2. Gerar checkout Stripe
      console.log('🔄 [Pagamento] Criando checkout Stripe para venda:', idVenda);
      const result = await apiCall(`VendaPagamento/create-checkout/${idVenda}`, 'POST');

      if (result && result.checkoutUrl) {
        console.log('✅ [Pagamento] Checkout Stripe criado:', result.checkoutUrl);
        setLinkPagamentoGerado(result.checkoutUrl);
        setLinkPagamentoCopiado(false);
        setShowPopupCompartilharPagamento(true);
      } else {
        const errorMsg = result?.error || result?.message || 'Erro ao criar checkout';
        alert('Erro ao criar checkout Stripe: ' + errorMsg);
      }
    } catch (error) {
      console.error('❌ [Pagamento] Erro ao confirmar pagamento:', error);
      alert('Erro ao processar pagamento: ' + (error.message || 'Erro desconhecido'));
    } finally {
      setProcessandoConfirmarPagamento(false);
      setGlobalLoading(false);
    }
  };

  // ==============================================
  // COMPARTILHAR LINK DE PAGAMENTO (copiar / whatsapp / email SMTP)
  // ==============================================
  const handleCopiarLinkPagamento = () => {
    if (!linkPagamentoGerado) return;
    navigator.clipboard.writeText(linkPagamentoGerado).then(() => {
      setLinkPagamentoCopiado(true);
      setTimeout(() => setLinkPagamentoCopiado(false), 3000);
    });
  };

  const handleCompartilharWhatsAppPagamento = () => {
    if (!linkPagamentoGerado) return;
    const mensagem = `Olá! Segue o link para pagamento da sua compra:\n\n${linkPagamentoGerado}\n\nPor favor, acesse o link para concluir o pagamento com segurança.`;
    window.open(`https://wa.me/?text=${encodeURIComponent(mensagem)}`, '_blank');
  };

  const handleEnviarEmailSMTPPagamento = async () => {
    if (!linkPagamentoGerado) return;
    setEmailEnviandoPagamento(true);
    try {
      const cliente = clientes.find(c => String(c.id || c.Id) === String(clienteSelecionadoId));
      const clienteEmail = cliente?.email || cliente?.Email || '';
      const clienteNome = cliente?.nome || cliente?.Nome || '';

      if (!clienteEmail) {
        setStatusPopupPagamento({ type: 'error', title: 'E-mail não encontrado', text: 'O cliente vinculado a esta venda não possui e-mail cadastrado.' });
        return;
      }

      const assunto = 'Link de Pagamento - S6 Gestão';
      const corpo = `<p>Prezado(a) ${clienteNome || 'cliente'},</p><p>Segue o link para pagamento da sua compra:</p><p><a href="${linkPagamentoGerado}">${linkPagamentoGerado}</a></p><p>Por favor, acesse o link para concluir o pagamento com segurança.</p><p>Atenciosamente.</p>`;

      const token = getAuthToken();
      const headers = { 'Content-Type': 'application/json' };
      if (token) headers['Authorization'] = 'Bearer ' + token;

      const resp = await fetch(`${BASE_URL}/Relacionamento_Clientes/enviar-email`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ EmailDestinatario: clienteEmail, Assunto: assunto, TemplateHtml: corpo })
      });
      const resultado = await resp.json().catch(() => null);

      if (resp.ok) {
        setStatusPopupPagamento({ type: 'success', title: 'E-mail enviado!', text: 'E-mail enviado com sucesso!', email: clienteEmail });
      } else {
        setStatusPopupPagamento({ type: 'error', title: 'Erro ao enviar', text: resultado?.message || 'Não foi possível enviar o e-mail.' });
      }
    } catch (e) {
      setStatusPopupPagamento({ type: 'error', title: 'Erro ao enviar', text: e.message || 'Erro desconhecido.' });
    } finally {
      setEmailEnviandoPagamento(false);
    }
  };

  // Verificar status do pagamento
  const verificarStatusPagamento = async () => {
    const idVenda = vendaAtual?.id || vendaAtual?.Id || vendaEdicao?.id || vendaEdicao?.Id;
    if (!idVenda) return;
    
    try {
      const result = await apiCall(`VendaPagamento/status/${idVenda}`);
      if (result && result.status) {
        setStatusPagamentoVenda(result.status);
      }
    } catch (e) {
      console.warn('Erro ao verificar status de pagamento:', e);
    }
  };

  // Verificar status do pagamento ao montar e periodicamente
  useEffect(() => {
    if (vendaAtual || vendaEdicao) {
      verificarStatusPagamento();
      // Verificar a cada 10 segundos enquanto pendente
      const interval = setInterval(() => {
        if (statusPagamentoVenda === 'pending') {
          verificarStatusPagamento();
        }
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [vendaAtual, vendaEdicao]);

  // Funções de pagamento (copiado do VendasDropdown)
  const fetchConfiguracoesPagamento = async () => {
    try {
      const data = await apiCall('ConfiguracaoPagamento');
      console.log('🧩 Configurações de pagamento carregadas:', data);
      setConfiguracoesPagamento(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('❌ Erro ao carregar configurações de pagamento:', e);
      setConfiguracoesPagamento([]);
    }
  };

  // Buscar entrega relacionada à venda em edição
  const fetchEntregaPorVenda = async () => {
    try {
      if (!vendaEdicao || !vendaEdicao.id) return;
      const todos = await apiCall('EntregaProduto');
      if (!Array.isArray(todos)) return;
      const ent = todos.find(e => e.VendaId === (vendaEdicao.id || vendaEdicao.Id));
      if (ent) setEntregaData(ent);
    } catch (e) {
      console.warn('Erro ao buscar entrega relacionada:', e);
    }
  };

  // carregar entrega ao abrir edição
  useEffect(() => {
    if (vendaEdicao) fetchEntregaPorVenda();
  }, [vendaEdicao]);

  // Carregar dados do comprador ao editar venda existente
  useEffect(() => {
    if (!vendaEdicao?.id) return;
    apiCall(`DadosCompradorVenda/por-venda/${vendaEdicao.id}`)
      .then(data => {
        if (!data || data.error || data.status === 404) return;
        const d = data;
        setCompradorExistenteId(d.id || d.Id);
        setMostrarDadosComprador(true);
        setDadosComprador({
          tipoDocumento: d.tipoDocumento || d.TipoDocumento || 'CPF',
          numeroDocumento: d.numeroDocumento || d.NumeroDocumento || '',
          nomeRazaoSocial: d.nomeRazaoSocial || d.NomeRazaoSocial || '',
          logradouro: d.logradouro || d.Logradouro || '',
          numero: d.numero || d.Numero || '',
          complemento: d.complemento || d.Complemento || '',
          bairro: d.bairro || d.Bairro || '',
          codigoMunicipioIBGE: d.codigoMunicipioIBGE || d.CodigoMunicipioIBGE || '',
          nomeMunicipio: d.nomeMunicipio || d.NomeMunicipio || '',
          uf: d.uf || d.UF || '',
          cep: d.cep || d.CEP || '',
          telefone: d.telefone || d.Telefone || '',
          email: d.email || d.Email || '',
          indicadorIE: d.indicadorIE || d.IndicadorIE || '9',
          inscricaoEstadual: d.inscricaoEstadual || d.InscricaoEstadual || '',
          regimeTributario: d.regimeTributario || d.RegimeTributario || 'SIMPLES',
          consumidorFinal: d.consumidorFinal ?? d.ConsumidorFinal ?? true,
          presencaComprador: d.presencaComprador || d.PresencaComprador || '1'
        });
      })
      .catch(() => {}); // sem dados do comprador ainda — ok
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendaEdicao]);

  // ===== Fechar dropdown ao clicar fora =====
  useEffect(() => {
    const handleClickFora = (e) => {
      if (clienteDropdownRef.current && !clienteDropdownRef.current.contains(e.target)) {
        setClienteDropdownAberto(false);
        setClienteBusca('');
      }
      if (vendedorDropdownRef.current && !vendedorDropdownRef.current.contains(e.target)) {
        setVendedorDropdownAberto(false);
        setVendedorBusca('');
      }
    };
    document.addEventListener('mousedown', handleClickFora);
    return () => document.removeEventListener('mousedown', handleClickFora);
  }, []);

  const handleVendedorChange = (valor) => {
    setVendedorSelecionadoId(valor);
    setVendedorDropdownAberto(false);
    setVendedorBusca('');
  };

  // ===== Auto-preenchimento dos dados do comprador ao selecionar cliente =====
  const handleClienteChange = (e) => {
    const selectedValue = e?.target?.value ?? e;
    setClienteSelecionadoId(selectedValue);
    setClienteDropdownAberto(false);
    setClienteBusca('');

    if (!selectedValue || selectedValue === 'outros') {
      // "Outros" ou nenhum selecionado: limpar dados do comprador
      setDadosComprador({
        tipoDocumento: 'CPF',
        numeroDocumento: '',
        nomeRazaoSocial: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        codigoMunicipioIBGE: '',
        nomeMunicipio: '',
        uf: '',
        cep: '',
        telefone: '',
        email: '',
        indicadorIE: '9',
        inscricaoEstadual: '',
        regimeTributario: 'SIMPLES',
        consumidorFinal: true,
        presencaComprador: '1'
      });
      return;
    }

    // Buscar dados do cliente selecionado
    const clienteId = parseInt(selectedValue);
    const cliente = clientes.find(c => (c.id || c.Id) === clienteId);
    if (!cliente) return;

    // Determinar tipo de documento
    const cpfCnpj = (cliente.cpF_CNPJ || cliente.CPF_CNPJ || cliente.cpf_cnpj || '').replace(/\D/g, '');
    const tipoPessoa = cliente.tipoPessoaId || cliente.TipoPessoaId;
    const ehPJ = tipoPessoa === 2 || cpfCnpj.length === 14;
    const tipoDoc = ehPJ ? 'CNPJ' : 'CPF';

    // Preencher dados do comprador automaticamente
    setDadosComprador({
      tipoDocumento: tipoDoc,
      numeroDocumento: cpfCnpj,
      nomeRazaoSocial: cliente.nome || cliente.Nome || '',
      logradouro: cliente.endereco || cliente.Endereco || '',
      numero: cliente.numero || cliente.Numero || '',
      complemento: cliente.complemento || cliente.Complemento || '',
      bairro: cliente.bairro || cliente.Bairro || '',
      codigoMunicipioIBGE: cliente.codigoMunicipio || cliente.CodigoMunicipio || '',
      nomeMunicipio: cliente.cidade || cliente.Cidade || '',
      uf: cliente.uf || cliente.UF || '',
      cep: (cliente.cep || cliente.CEP || '').replace(/\D/g, ''),
      telefone: cliente.celular || cliente.Celular || '',
      email: cliente.email || cliente.Email || '',
      indicadorIE: (cliente.inscricaoEstadual || cliente.InscricaoEstadual) ? '1' : '9',
      inscricaoEstadual: cliente.inscricaoEstadual || cliente.InscricaoEstadual || '',
      regimeTributario: 'SIMPLES',
      consumidorFinal: true,
      presencaComprador: '1'
    });

    // Abrir seção de dados do comprador automaticamente
    setMostrarDadosComprador(true);
  };

  const handleSelectFiles = (files) => {
    const arr = Array.from(files || []);
    setUploadFiles(arr);
    const previews = arr.map(f => ({ name: f.name, url: URL.createObjectURL(f) }));
    setUploadPreviews(previews);
  };

  const handleUploadFotos = async () => {
    if (!entregaData || !entregaData.Id && !entregaData.id) {
      alert('Nenhuma entrega encontrada para enviar fotos.');
      return;
    }
    const entregaId = entregaData.Id || entregaData.id;
    if (!uploadFiles || uploadFiles.length === 0) {
      alert('Selecione ao menos uma imagem para enviar.');
      return;
    }

    setUploadingFotos(true);
    try {
      // montar formdata
      const form = new FormData();
      uploadFiles.forEach(f => form.append('files', f, f.name));

      // Tentar múltiplas bases
      const bases = [
        `${BASE_URL}/`,
        `${BASE_URL}/`,
        `${BASE_URL}/`,
        `${BASE_URL}/`,
        `${BASE_URL}/`
      ];

      let ok = false;
      for (const base of bases) {
        try {
          const url = `${base}EntregaProduto/${entregaId}/fotos`;
          const token = getAuthToken ? getAuthToken() : localStorage.getItem('authToken');
          const headers = token ? { 'Authorization': 'Bearer ' + token } : {};
          const res = await fetch(url, { method: 'POST', headers, body: form });
          if (res.ok) {
            ok = true;
            break;
          }
        } catch (err) {
          console.warn('Erro upload fotos para', base, err.message);
        }
      }

      if (ok) {
        alert('Fotos enviadas com sucesso');
        // recarregar informações da entrega
        await fetchEntregaPorVenda();
        // limpar previews
        uploadPreviews.forEach(p => URL.revokeObjectURL(p.url));
        setUploadFiles([]);
        setUploadPreviews([]);
      } else {
        alert('Não foi possível enviar as fotos. Verifique o backend.');
      }
    } catch (err) {
      console.error('Erro ao enviar fotos:', err);
      alert('Erro ao enviar fotos: ' + (err.message || 'desconhecido'));
    } finally {
      setUploadingFotos(false);
    }
  };

  // Funções para gerenciar items (carrinho)
  const adicionarItemLocal = (item) => {
    setItems(prev => {
      const next = [...prev, item];
      if (typeof onAdicionarItem === 'function') onAdicionarItem(item);
      return next;
    });
  };

  const atualizarItemLocal = (index, item) => {
    setItems(prev => {
      const next = prev.map((it, i) => i === index ? item : it);
      if (typeof onAtualizarItem === 'function') onAtualizarItem(index, item);
      return next;
    });
  };

  const removerItemLocal = (index) => {
    setItems(prev => {
      const itemRemovido = prev[index];
      const next = prev.filter((_, i) => i !== index);
      if (typeof onRemoverItem === 'function') onRemoverItem(index, itemRemovido);
      return next;
    });
  };

  const filtrarConfiguracoesPorTipo = (tipoId) => {
    if (!tipoId) {
      setConfiguracoesFiltradas([]);
      return;
    }
    const filtradas = configuracoesPagamento.filter(c => (c.tipoPagamentoId || c.TipoPagamentoId) === tipoId);
    setConfiguracoesFiltradas(filtradas);
  };

  // Se a filtragem resultar em apenas 1 configuração, selecioná-la automaticamente e executar cálculo
  useEffect(() => {
    try {
      if (Array.isArray(configuracoesFiltradas) && configuracoesFiltradas.length === 1) {
        const cfg = configuracoesFiltradas[0];
        const id = cfg.id || cfg.Id;
        if (id && configuracaoSelecionadaId !== id) {
          setConfiguracaoSelecionadaId(id);
          // ajustar DOM se possível
          setTimeout(() => {
            const form = document.querySelector('form[data-calculo="vendaProduto"]');
            if (form && form.configuracaoPagamentoId) form.configuracaoPagamentoId.value = id;
            // sincronizar tipo juros e parcelas
            const maxParcelas = cfg.maximoParcelas || cfg.MaximoParcelas || 1;
            setQuantidadeParcelas(q => Math.min(q || 1, maxParcelas));
            setTipoJurosUI(cfg.tipoJuros || cfg.TipoJuros || '');

            // executar cálculo com valores atuais
            setTimeout(() => {
              const formEl = document.querySelector('form[data-calculo="vendaProduto"]');
              if (formEl && produtoSelecionado) {
                const preco = parseFloat(produtoSelecionado?.preco || 0);
                const quantidade = parseInt(formEl.quantidade?.value || 1);
                const desconto = parseFloat(formEl.desconto?.value || 0);
                const impostos = parseFloat(formEl.impostos?.value || 0);
                const valorBase = (preco * quantidade) - desconto + impostos;
                executarCalculoPagamento(Math.max(0, valorBase));
              }
            }, 120);
          }, 60);
        }
      }
    } catch (e) {
      console.warn('Erro ao auto-selecionar configuração:', e);
    }
  }, [configuracoesFiltradas]);

  const handleTipoPagamentoChange = (e) => {
    const id = parseInt(e.target.value) || null;
    setTipoPagamentoSelecionado(id);
    setConfiguracaoSelecionadaId(null);
    setCalculoPagamento(null);
    setQuantidadeParcelas(1);
    filtrarConfiguracoesPorTipo(id);
  };

  const handleConfiguracaoChange = (e) => {
    const id = parseInt(e.target.value) || null;
    setConfiguracaoSelecionadaId(id);
    setCalculoPagamento(null);
    setErroCalculo('');
    const cfg = configuracoesPagamento.find(c => (c.id || c.Id) === id);
    if (cfg) {
      const maxParcelas = cfg.maximoParcelas || cfg.MaximoParcelas || 1;
      setQuantidadeParcelas(Math.min(quantidadeParcelas, maxParcelas));
      setTipoJurosUI(cfg.tipoJuros || cfg.TipoJuros || '');
      
      // Executar cálculo automaticamente após seleção
      setTimeout(() => {
        const form = document.querySelector('form[data-calculo="vendaProduto"]');
        if (form && produtoSelecionado) {
          const preco = parseFloat(produtoSelecionado?.preco || 0);
          const quantidade = parseInt(form.quantidade?.value || 1);
          const desconto = parseFloat(form.desconto?.value || 0);
          const impostos = parseFloat(form.impostos?.value || 0);
          
          const valorBase = (preco * quantidade) - desconto + impostos;
          executarCalculoPagamento(Math.max(0, valorBase));
        }
      }, 100);
    }
  };

  // useEffect para cálculo automático quando campos mudarem
  useEffect(() => {
    if (configuracaoSelecionadaId && produtoSelecionado) {
      const timeout = setTimeout(() => {
        const form = document.querySelector('form[data-calculo="vendaProduto"]');
        if (form) {
          const preco = parseFloat(produtoSelecionado?.preco || 0);
          const quantidade = parseInt(form.quantidade?.value || 1);
          const desconto = parseFloat(form.desconto?.value || 0);
          const impostos = parseFloat(form.impostos?.value || 0);
          
          const valorBase = (preco * quantidade) - desconto + impostos;
          executarCalculoPagamento(Math.max(0, valorBase));
        }
      }, 500);
      
      return () => clearTimeout(timeout);
    }
  }, [configuracaoSelecionadaId, quantidadeParcelas, produtoSelecionado]);

  // useEffect para recalcular quando quantidade de parcelas muda
  useEffect(() => {
    if (configuracaoSelecionadaId && produtoSelecionado && quantidadeParcelas > 0) {
      const timeout = setTimeout(() => {
        const form = document.querySelector('form[data-calculo="vendaProduto"]');
        if (form) {
          const preco = parseFloat(produtoSelecionado?.preco || 0);
          const quantidade = parseInt(form.quantidade?.value || 1);
          const desconto = parseFloat(form.desconto?.value || 0);
          const impostos = parseFloat(form.impostos?.value || 0);
          
          const valorBase = (preco * quantidade) - desconto + impostos;
          executarCalculoPagamento(Math.max(0, valorBase));
        }
      }, 300);
      
      return () => clearTimeout(timeout);
    }
  }, [quantidadeParcelas]);

  // useEffect para observar mudanças nos campos do formulário
  useEffect(() => {
    const form = document.querySelector('form[data-calculo="vendaProduto"]');
    if (!form) return;

    const handleInputChange = () => {
      if (configuracaoSelecionadaId && produtoSelecionado) {
        const preco = parseFloat(produtoSelecionado?.preco || 0);
        const quantidade = parseInt(form.quantidade?.value || 1);
        const desconto = parseFloat(form.desconto?.value || 0);
        const impostos = parseFloat(form.impostos?.value || 0);
        
        const valorBase = (preco * quantidade) - desconto + impostos;
        executarCalculoPagamento(Math.max(0, valorBase));
      }
    };

    const fields = ['quantidade', 'desconto', 'quantidadeParcelas'];
    const listeners = [];

    fields.forEach(fieldName => {
      const field = form[fieldName];
      if (field) {
        field.addEventListener('input', handleInputChange);
        field.addEventListener('change', handleInputChange);
        listeners.push({ field, type: 'input', handler: handleInputChange });
        listeners.push({ field, type: 'change', handler: handleInputChange });
      }
    });

    return () => {
      listeners.forEach(({ field, type, handler }) => {
        field.removeEventListener(type, handler);
      });
    };
  }, [configuracaoSelecionadaId, produtoSelecionado]);

  const executarCalculoPagamento = (valorOriginalBase) => {
    if (!configuracaoSelecionadaId) {
      setErroCalculo('');
      return;
    }
    setErroCalculo('');
    setCarregandoCalculo(true);
    try {
      const cfg = configuracoesPagamento.find(c => (c.id || c.Id) === configuracaoSelecionadaId) || {};
      const tipoJuros = (cfg.tipoJuros || cfg.TipoJuros || '').toUpperCase();
      const taxa = parseFloat(cfg.valorJuros ?? cfg.ValorJuros) || 0;
      const descricaoJuros = (cfg.configuracaoJurosDescricao || cfg.ConfiguracaoJurosDescricao || '').toUpperCase();
      const modalidade = (cfg.modalidadePagamentoDescricao || cfg.ModalidadePagamentoDescricao || '').toUpperCase();
      const isAVista = modalidade.includes('VISTA');
      const temJuros = descricaoJuros.includes('COM') && taxa > 0 && tipoJuros !== '';
      const qtd = Math.max(1, parseInt(quantidadeParcelas) || 1);

      let valorOriginal = valorOriginalBase;
      let valorComJuros = valorOriginal;
      let valorJuros = 0;
      let observacao = '';

      if (temJuros) {
        if (tipoJuros === 'ABSOLUTO') {
          valorJuros = taxa;
          valorComJuros = valorOriginal + valorJuros;
          observacao = `Juros absoluto R$ ${valorJuros.toFixed(2)}`;
        } else if (tipoJuros === 'PERCENTUAL') {
          if (!isAVista && qtd > 1) {
            const fator = 1 + (taxa / 100);
            valorComJuros = valorOriginal * Math.pow(fator, qtd);
            valorJuros = valorComJuros - valorOriginal;
            observacao = `Juros composto ${taxa}% por parcela (${qtd}x)`;
          } else {
            valorJuros = (valorOriginal * taxa) / 100;
            valorComJuros = valorOriginal + valorJuros;
            observacao = `Juros simples ${taxa}%`;
          }
        }
      } else {
        observacao = 'Sem juros';
      }

      const valorParcelaBruto = valorComJuros / qtd;
      const parcelas = [];
      for (let i = 1; i <= qtd; i++) {
        let valorParcela = valorParcelaBruto;
        if (i === qtd) {
          const somaAnteriores = valorParcelaBruto * (qtd - 1);
          valorParcela = valorComJuros - somaAnteriores;
        }
        const data = new Date(dataInicioVencimento || new Date().toISOString().split('T')[0]);
        data.setMonth(data.getMonth() + (i - 1));
        parcelas.push({
          numeroParcela: i,
          valorParcela: valorParcela,
          dataVencimento: data.toISOString(),
          observacoes: i === qtd ? 'Parcela final (ajuste)' : null
        });
      }

      const simulacao = {
        valorOriginal,
        valorJuros,
        valorFinal: valorComJuros,
        quantidadeParcelas: qtd,
        valorParcela: valorParcelaBruto,
        parcelas,
        observacaoCalculo: observacao + ' (simulação local)'
      };

      setCalculoPagamento(simulacao);
      
      // Atualizar campos na interface com os valores calculados
      const form = document.querySelector('form[data-calculo="vendaProduto"]');
      if (form) {
        // Atualizar o tipo de juros na UI
        setTipoJurosUI(tipoJuros);
        
        // Atualizar quantidade de parcelas se mudou
        if (form.quantidadeParcelas) {
          form.quantidadeParcelas.value = qtd;
        }
        
        // Atualizar também a configuração de pagamento com os valores calculados
        const updatedConfiguracoes = configuracoesPagamento.map(config => {
          if ((config.id || config.Id) === configuracaoSelecionadaId) {
            return {
              ...config,
              tipoJuros: tipoJuros,
              valorJuros: taxa,
              TipoJuros: tipoJuros,
              ValorJuros: taxa
            };
          }
          return config;
        });
        setConfiguracoesPagamento(updatedConfiguracoes);
        
        // Recalcular o total com os novos valores
        calcularTotal();
      }
    } catch (e) {
      setErroCalculo('Erro ao simular: ' + (e.message || 'desconhecido'));
    } finally {
      setCarregandoCalculo(false);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setGlobalLoading(true);

    // Coletar dados do formulário
    const formData = new FormData(e.target);
    const quantidade = parseInt(formData.get('quantidade')) || 1;
    const precoUnitario = produtoSelecionado?.preco || 0;
    const desconto = parseFloat(formData.get('desconto')) || 0;
    const impostos = parseFloat(formData.get('impostos')) || 0;

    // Calcular valor base - se há items no carrinho, somar valores dos items
    let valorBase = 0;
    if (items && items.length > 0) {
      // Calcular valor base a partir dos itens do carrinho
      valorBase = items.reduce((total, item) => {
        const precoItem = parseFloat(item.precoUnitario || item.PrecoUnitario || item.preco || 0);
        const qtdItem = parseInt(item.quantidade || item.Quantidade || 1);
        return total + (precoItem * qtdItem);
      }, 0);
      console.log('🛒 Valor base calculado a partir dos itens:', valorBase);
    } else {
      // Produto único - usar quantidade * preço unitário
      valorBase = (quantidade * precoUnitario);
    }
    const valorComDescontoImpostos = valorBase - desconto + impostos;

    // Lógica de juros padronizada
    let tipoJurosId = 2; // padrão absoluto
    let valorJurosFinal = 0;

    // Buscar config de pagamento selecionada
    const cfgPagamento = configuracoesPagamento.find(c => (c.id || c.Id) === configuracaoSelecionadaId) || {};
    const descricaoJuros = (cfgPagamento.configuracaoJurosDescricao || cfgPagamento.ConfiguracaoJurosDescricao || '').toUpperCase();
    const modalidade = (cfgPagamento.modalidadePagamentoDescricao || cfgPagamento.ModalidadePagamentoDescricao || '').toUpperCase();
    const temJuros = descricaoJuros.includes('COM');

    // Se não houver tipo de juros selecionado OU modalidade sem juros (ex: PIX, dinheiro)
    if (!tipoJurosUI || !temJuros) {
      tipoJurosId = 2; // absoluto
      valorJurosFinal = 0;
    } else {
      // Modalidade com juros: seguir seleção do usuário
      const tipo = tipoJurosUI.toUpperCase();
      if (tipo === 'ABSOLUTO') {
        tipoJurosId = 2;
        valorJurosFinal = calculoPagamento?.valorJuros ?? cfgPagamento.valorJuros ?? cfgPagamento.ValorJuros ?? 0;
      } else if (tipo === 'PERCENTUAL') {
        tipoJurosId = 3;
        valorJurosFinal = calculoPagamento?.valorJuros ?? cfgPagamento.valorJuros ?? cfgPagamento.ValorJuros ?? 0;
      } else if (tipo === 'SEM JUROS') {
        // Se usuário escolher "sem juros", forçar absoluto e valor 0
        tipoJurosId = 2;
        valorJurosFinal = 0;
        setTipoJurosUI('ABSOLUTO');
      } else {
        tipoJurosId = 2;
        valorJurosFinal = 0;
      }
    }

    const vendaData = {
      ProdutoId: produtoSelecionado?.id,
      QuantidadeProduto: quantidade,
      TipoVendaId: 1,
      TipoVendaNatureza: 'produto', // natureza da venda: produto
      OrcamentoID: null,
      ValorOrc: null,
      ValorVenda: valorComDescontoImpostos,
      Desconto: desconto,
      Impostos: impostos,
      ConfiguracaoPagamentoId: configuracaoSelecionadaId || null,
      QuantidadeParcelas: calculoPagamento?.quantidadeParcelas || parseInt(formData.get('quantidadeParcelas')) || 1,
      ValorParcela: calculoPagamento?.valorParcela || null,
      ValorJuros: valorJurosFinal,
      ValorFinal: calculoPagamento?.valorFinal || valorComDescontoImpostos,
      ValorOriginal: valorBase,
      ClineteId: clienteSelecionadoId && clienteSelecionadoId !== 'outros' ? parseInt(clienteSelecionadoId) : null,
      DataVenda: formData.get('dataVenda') || new Date().toISOString().split('T')[0],
      StatusVenda: formData.get('statusVenda') || 'Pendente',
      VendedorId: vendedorSelecionadoId ? parseInt(vendedorSelecionadoId) : null,
      TipoPagamentoId: tipoPagamentoSelecionado || parseInt(formData.get('tipoPagamentoId')) || null,
      CampanhaId: null,
      StatusEntrega: 'Pendente',
      DataEntregaProgramada: formData.get('dataEntrega') ? new Date(formData.get('dataEntrega')).toISOString() : null,
      EstoqueReservado: false,
      Notas: formData.get('notas') || `Venda de produto: ${produtoSelecionado?.nome} (Qtd: ${quantidade})`,
      DescricaoOrcamento: `Venda direta de produto: ${produtoSelecionado?.nome}`,
      TipoJurosId: tipoJurosId,
      ValorJuros: valorJurosFinal
    };
    
    try {
      console.log('📤 Enviando venda de produto:', vendaData);
      console.log('🔧 Configuração de pagamento ID:', configuracaoSelecionadaId);
      console.log('� Quantidade de parcelas (state):', quantidadeParcelas);
      console.log('�💰 Cálculo de pagamento:', calculoPagamento);
      console.log('� Data início vencimento:', dataInicioVencimento);
      
      // Validações básicas
      if (items && items.length > 0) {
        // validar cada item (suporte a variações de nomes retornados pelo backend)
        for (let idx = 0; idx < items.length; idx++) {
          const it = items[idx];
          const prodId = it.produtoId || it.ProdutoId || (it.produto && (it.produto.id || it.produto.Id)) || it.id || null;
          if (!prodId || parseInt(prodId) === 0) {
            throw new Error(`Um dos itens (posição ${idx + 1}) não possui produto selecionado: ${it.nome || it.Nome || ''}`);
          }
          const quantidadeItem = parseInt(it.quantidade || it.Quantidade) || 0;
          if (!quantidadeItem || quantidadeItem < 1) {
            throw new Error(`Quantidade inválida no item ${it.nome || idx + 1}`);
          }
          // checar estoque disponível quando fornecido no item
          const estoqueDisp = parseInt(it.estoque || it.Estoque || (it.produto && (it.produto.estoque || it.produto.Estoque)) || 0);
          if (estoqueDisp > 0 && quantidadeItem > estoqueDisp) {
            throw new Error(`Quantidade do item ${it.nome || it.Nome || ''} (${quantidadeItem}) excede o estoque disponível (${estoqueDisp}).`);
          }
        }
      } else {
        if (!produtoSelecionado?.id) {
          throw new Error('Produto não selecionado');
        }
      }
    
      // ClineteId pode ser null quando "Outros" é selecionado
      // Não é mais obrigatório
      
      if (configuracaoSelecionadaId && (!quantidadeParcelas || quantidadeParcelas < 1)) {
        throw new Error('Quantidade de parcelas inválida quando há configuração de pagamento');
      }
      
      let response;
      
  if (vendaEdicao && vendaEdicao.id) {
        // EDIÇÃO - Atualizar venda existente
        console.log('✏️ Editando venda existente:', vendaEdicao.id);
        
        // Adicionar ID da venda ao objeto
        vendaData.Id = vendaEdicao.id;
        
  // sempre pega do select
  vendaData.TipoJurosId = tipoJurosId;
  vendaData.ValorJuros = valorJurosFinal;
        
        // No modo edição, persistir snapshot final do carrinho apenas ao salvar
        const itensDtoEdicao = (items || []).map(it => ({
          ProdutoId: parseInt(it.produtoId || it.ProdutoId || it.id || 0) || 0,
          Quantidade: parseInt(it.quantidade || it.Quantidade || 1) || 1,
          ValorUnitario: parseFloat(it.precoUnitario || it.PrecoUnitario || it.preco || 0) || 0
        })).filter(it => it.ProdutoId > 0 && it.Quantidade > 0);

        const requestWrapperEdicao = {
          Venda: vendaData,
          Itens: itensDtoEdicao
        };

        console.log('📦 Dados para edição (wrapper com itens):', requestWrapperEdicao);
        
        const enviarAtualizacaoVenda = async (permitirAprovacaoSemNf = false) => {
          const payload = {
            ...requestWrapperEdicao,
            permitirAprovacaoSemNf
          };
          return await apiCall(`Vendas/${vendaEdicao.id}`, 'PUT', payload);
        };

        try {
          response = await enviarAtualizacaoVenda(false);
        } catch (errAprovacao) {
          const code = errAprovacao?.code || errAprovacao?.payload?.code;
          const precisaConfirmarSemNf = errAprovacao?.status === 409 && code === 'NF_CADASTRAL_REQUIRED_CONFIRMATION';

          if (!precisaConfirmarSemNf) throw errAprovacao;

          const detalheCadastro = errAprovacao?.payload?.detalhes || errAprovacao?.message || 'Erro cadastral de CPF/CNPJ para emissão da Nota Fiscal.';
          const confirmar = window.confirm(
            `Atenção: a venda será aprovada, mas a Nota Fiscal não será gerada agora.\n\n` +
            `Motivo: ${detalheCadastro}\n\n` +
            `Isso acontece por erros cadastrais de CPF (PF) ou CNPJ (PJ). Até a correção cadastral, a NF não será gerada.\n\n` +
            `Deseja prosseguir mesmo assim, sem gerar NF neste momento?`
          );

          if (!confirmar) {
            setGlobalLoading(false);
            return;
          }

          response = await enviarAtualizacaoVenda(true);
        }
        
        console.log('✅ Venda de produto atualizada com sucesso:', response);
        const nfErro = response?.notaFiscal?.erro || response?.NotaFiscal?.erro;
        const nfErroCadastral =
          response?.notaFiscal?.erroCadastral === true ||
          response?.NotaFiscal?.erroCadastral === true;

        if (nfErroCadastral) {
          alert(
            'Venda aprovada com sucesso, porém a Nota Fiscal não foi gerada por erro cadastral.\n\n' +
            'Verifique os dados de CPF (conta PF) ou CNPJ (conta PJ) da empresa/comprador.\n' +
            'Até a correção desses dados cadastrais, a NF não será gerada.\n\n' +
            `Detalhe: ${nfErro}`
          );
        } else {
          alert('Venda de produto atualizada com sucesso!');
        }
        // Se houver entrega relacionada e arquivos para upload, enviar para o PUT de entrega
        try {
          const entregaId = entregaData && (entregaData.Id || entregaData.id);
          if (entregaId && uploadFiles && uploadFiles.length > 0) {
            // construir FormData com campos existentes da entrega (ou usar valores mínimos)
            const form = new FormData();
            // incluir campos existentes da entrega para não sobrescrever com nulls
            const campos = ['VendaId','ClienteId','ProdutoId','Status','DataProgramada','DataEntrega','DataCancelamento','RecebedorNome','RecebedorDocumento','EntregadorNome','EntregadorDocumento','EnderecoEntrega','CidadeEntrega','UFEntrega','CEPEntrega','ComplementoEntrega','Observacoes','MotivoColamento','QuantidadeEntregue','EstoqueJaAtualizado'];
            campos.forEach(c => {
              const keyLower = c.charAt(0).toLowerCase() + c.slice(1);
              const val = entregaData[c] ?? entregaData[keyLower] ?? entregaData[c.toLowerCase()];
              if (val !== undefined && val !== null) form.append(c, val);
            });
            // anexar arquivos
            uploadFiles.forEach(f => form.append('files', f, f.name));

            // tentar em múltiplas bases
            const bases = [
              `${BASE_URL}/`,
              `${BASE_URL}/`,
              `${BASE_URL}/`,
              `${BASE_URL}/`,
              `${BASE_URL}/`
            ];
            let enviado = false;
            for (const base of bases) {
              try {
                const url = `${base}EntregaProduto/${entregaId}`;
                const token = getAuthToken ? getAuthToken() : localStorage.getItem('authToken');
                const headers = token ? { 'Authorization': 'Bearer ' + token } : {};
                const res = await fetch(url, { method: 'PUT', headers, body: form });
                if (res.ok || res.status === 204) {
                  enviado = true;
                  break;
                }
              } catch (err) {
                console.warn('Erro ao enviar fotos no PUT de entrega para', base, err.message);
              }
            }

            if (enviado) {
              // recarregar entrega
              await fetchEntregaPorVenda();
              alert('Fotos da entrega enviadas com sucesso.');
              // limpar previews
              uploadPreviews.forEach(p => URL.revokeObjectURL(p.url));
              setUploadFiles([]);
              setUploadPreviews([]);
            } else {
              alert('Não foi possível enviar as fotos da entrega via PUT. Tente novamente.');
            }
          }
        } catch (err) {
          console.warn('Erro ao tentar enviar fotos na atualização da entrega:', err);
        }
        
      } else {
        if (items && items.length > 0) {
          // CRIAÇÃO - múltiplos itens: enviar um único POST com Itens (ProdutoItemDto[])
          console.log('➕ Criando venda única com múltiplos itens:', items.length);
          console.log('🛒 Items no carrinho:', items);

          // construir array de itens no formato esperado pelo backend
          const itensDto = (items || []).map(it => ({
            ProdutoId: parseInt(it.produtoId) || 0,
            Quantidade: parseInt(it.quantidade) || 1,
            ValorUnitario: parseFloat(it.precoUnitario || 0) || 0
          }));

          console.log('📦 ItensDto para o backend:', itensDto);

          // montar a venda principal (remover campos que representam venda por item único)
          const vendaWrapper = Object.assign({}, vendaData);
          // garantir que campos individuais de produto não conflitem
          vendaWrapper.ProdutoId = null;
          vendaWrapper.QuantidadeProduto = null;
          vendaWrapper.TipoVendaId = 1;
          vendaWrapper.TipoVendaNatureza = 'produto'; // natureza da venda: produto

          console.log('💰 VendaWrapper com valores:', {
            ValorVenda: vendaWrapper.ValorVenda,
            ValorFinal: vendaWrapper.ValorFinal,
            ValorOriginal: vendaWrapper.ValorOriginal,
            Desconto: vendaWrapper.Desconto,
            Impostos: vendaWrapper.Impostos
          });

          const requestWrapperItem = {
            Venda: vendaWrapper,
            Itens: itensDto,
            ConfiguracaoPagamentoId: configuracaoSelecionadaId || null,
            QuantidadeParcelas: calculoPagamento?.quantidadeParcelas || parseInt(quantidadeParcelas) || 1,
            DataInicioVencimento: dataInicioVencimento ? new Date(dataInicioVencimento).toISOString() : null,
            UsarCalculoCustomizado: false
          };

          // Anexar dados do cartão se o tipo de pagamento for cartão
          try {
            if (isCardPaymentType()) {
              requestWrapperItem.Venda.DadosCartao = {
                NumeroCartao: numeroCartao || undefined,
                NomeTitular: nomeTitular || undefined,
                MesVencimento: mesVencimento || undefined,
                AnoVencimento: anoVencimento || undefined,
                CodigoSeguranca: codigoSeguranca || undefined
              };
            }
          } catch (e) {
            console.warn('Erro ao anexar dados do cartão no wrapper de itens:', e);
          }

          console.log('📦 Enviando venda com itens:', requestWrapperItem);
          const resp = await apiCall('Vendas', 'POST', requestWrapperItem);
          response = resp;
          console.log('✅ Venda com múltiplos itens criada com sucesso:', response);
          alert('Venda criada com múltiplos itens com sucesso!');
        } else {
          // CRIAÇÃO - Nova venda (produto único)
          console.log('➕ Criando nova venda de produto');
          const requestWrapper = {
            Venda: vendaData,
            ConfiguracaoPagamentoId: configuracaoSelecionadaId || null,
            QuantidadeParcelas: calculoPagamento?.quantidadeParcelas || parseInt(quantidadeParcelas) || 1,
            DataInicioVencimento: dataInicioVencimento ? new Date(dataInicioVencimento).toISOString() : null,
            UsarCalculoCustomizado: calculoPagamento ? true : false,
            ValorJurosCustomizado: calculoPagamento?.valorJuros || null,
            ValorFinalCustomizado: calculoPagamento?.valorFinal || null,
            ValorParcelaCustomizada: calculoPagamento?.valorParcela || null,
            TipoJurosCustomizado: tipoJurosUI || null
          };

          // Anexar DadosCartao ao wrapper quando necessário
          try {
            if (isCardPaymentType()) {
              requestWrapper.Venda.DadosCartao = {
                NumeroCartao: numeroCartao || undefined,
                NomeTitular: nomeTitular || undefined,
                MesVencimento: mesVencimento || undefined,
                AnoVencimento: anoVencimento || undefined,
                CodigoSeguranca: codigoSeguranca || undefined
              };
            }
          } catch (e) {
            console.warn('Erro ao anexar dados do cartão no wrapper:', e);
          }

          console.log('📦 Wrapper para criação:', requestWrapper);
          response = await apiCall('Vendas', 'POST', requestWrapper);
          console.log('✅ Venda de produto criada com sucesso:', response);
          alert('Venda de produto criada com sucesso!');
        }
      }
      
      // Verificar se a venda foi aprovada - se sim, não fechar o popup
      const statusSalvo = response?.statusVenda || response?.StatusVenda || vendaData.StatusVenda;
      const vendaIdSalvo = response?.id || response?.Id || response?.venda?.id || response?.venda?.Id;

      // ===== Salvar dados do comprador (sempre que houver dados preenchidos) =====
      const temAlgumDadoComprador = dadosComprador.nomeRazaoSocial || dadosComprador.numeroDocumento || dadosComprador.logradouro || dadosComprador.bairro || dadosComprador.nomeMunicipio || dadosComprador.uf || dadosComprador.cep || dadosComprador.email || dadosComprador.telefone;
      if (temAlgumDadoComprador && vendaIdSalvo) {
        try {
          const compradorPayload = {
            VendaId: vendaIdSalvo,
            TipoDocumento: dadosComprador.tipoDocumento,
            NumeroDocumento: dadosComprador.numeroDocumento.replace(/\D/g, ''),
            NomeRazaoSocial: dadosComprador.nomeRazaoSocial,
            Logradouro: dadosComprador.logradouro || 'Não informado',
            Numero: dadosComprador.numero || 'S/N',
            Complemento: dadosComprador.complemento || null,
            Bairro: dadosComprador.bairro || 'Não informado',
            CodigoMunicipioIBGE: dadosComprador.codigoMunicipioIBGE || '0000000',
            NomeMunicipio: dadosComprador.nomeMunicipio || 'Não informado',
            UF: dadosComprador.uf,
            CEP: dadosComprador.cep.replace(/\D/g, '') || '00000000',
            CodigoPais: '1058',
            NomePais: 'Brasil',
            Telefone: dadosComprador.telefone || null,
            Email: dadosComprador.email || null,
            IndicadorIE: dadosComprador.indicadorIE,
            InscricaoEstadual: dadosComprador.inscricaoEstadual || null,
            RegimeTributario: dadosComprador.regimeTributario,
            TipoOperacao: 'VENDA_DENTRO_ESTADO',
            ConsumidorFinal: dadosComprador.consumidorFinal,
            PresencaComprador: dadosComprador.presencaComprador,
            FinalidadeNFe: '1'
          };
          if (compradorExistenteId) {
            await apiCall(`DadosCompradorVenda/${compradorExistenteId}`, 'PUT', { ...compradorPayload, Id: compradorExistenteId });
          } else {
            const compradorResp = await apiCall('DadosCompradorVenda', 'POST', compradorPayload);
            const novoId = compradorResp?.id || compradorResp?.Id;
            if (novoId) setCompradorExistenteId(novoId);
          }
          console.log('✅ Dados do comprador salvos com sucesso');
        } catch (errComprador) {
          console.warn('⚠️ Dados do comprador não salvos (não crítico):', errComprador?.message);
        }
      }

      if (statusSalvo === 'Aprovada' && vendaIdSalvo) {
        // Atualizar o estado local com a venda salva para mostrar opção de pagamento
        const vendaSalva = response?.venda || response;
        setVendaAtual({
          ...vendaSalva,
          id: vendaIdSalvo,
          statusVenda: 'Aprovada',
          statusPagamento: vendaSalva?.statusPagamento || vendaSalva?.StatusPagamento || 'pending'
        });
        setStatusPagamentoVenda(vendaSalva?.statusPagamento || vendaSalva?.StatusPagamento || 'pending');
        
        // NÃO fechar o popup - mostrar opção de pagamento
        alert('Venda aprovada! Agora você pode realizar o pagamento.');
        return; // Não chamar onSalvar para não fechar o popup
      }
      
      if (onSalvar) {
        onSalvar(response);
      }
    } catch (error) {
      const operacao = vendaEdicao ? 'atualizar' : 'criar';
      console.error(`❌ Erro ao ${operacao} venda de produto:`, error);
      alert(`Erro ao ${operacao} venda de produto: ` + (error.message || 'Erro desconhecido'));
    } finally {
      setGlobalLoading(false);
    }
  };

  if (!produtoSelecionado) {
    return null;
  }

  // Verificar se a venda está aprovada para bloquear campos
  const vendaAprovada = vendaEdicao && 
    (vendaEdicao.statusVenda === 'Aprovada' || vendaEdicao.StatusVenda === 'Aprovada');

  // Cancelar venda aprovada
  const handleConfirmarCancelamento = async () => {
    if (!vendaEdicao?.id) return;
    setCancellandoVenda(true);
    try {
      await apiCall(`Vendas/${vendaEdicao.id}`, 'PUT', {
        ...vendaEdicao,
        StatusVenda: 'Cancelada',
        statusVenda: 'Cancelada',
      });
      setPopupCancelarVenda(false);
      alert('Venda cancelada com sucesso.');
      if (onSalvar) onSalvar({ ...vendaEdicao, statusVenda: 'Cancelada' });
    } catch (err) {
      alert('Erro ao cancelar venda: ' + (err.message || err));
    } finally {
      setCancellandoVenda(false);
    }
  };

  return (
    <div className="popup-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 'var(--z-popup)'
    }}>
      <LoadingOverlay isLoading={globalLoading} message={vendaEdicao ? 'Salvando alterações...' : 'Criando venda...'} />
      <div className="popup-content" style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '0',
        width: '95%',
        maxWidth: '900px',
        maxHeight: '95vh',
        overflow: 'auto',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <BotaoVoltarTopo />
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '20px',
          position: 'relative'
        }}>
          {/* Botão de fechar */}
          <button
            type="button"
            onClick={onCancelar}
            aria-label="Fechar"
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              backgroundColor: 'rgb(235, 133, 0)',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              fontSize: '18px',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
            title="Fechar"
          >
            ×
          </button>
          
          <div className="popup-titulo-laranja">
            {vendaEdicao ? 'Editar Venda de Produto' : 'Nova Venda de Produto'}
          </div>
          
          {/* Aviso de venda aprovada */}
          {vendaAprovada && (
            <>
              <div style={{
                background: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '6px',
                padding: '12px',
                margin: '15px 0',
                color: '#856404',
                textAlign: 'center',
                width: '100%',
                maxWidth: '800px'
              }}>
                <strong>⚠️ Venda Aprovada:</strong> Esta venda já foi aprovada e não pode ser editada. Todos os campos estão bloqueados para visualização.
              </div>

            </>
          )}
          
          <form 
            id="venda-prod-form"
            className="formulario-venda"
            data-calculo="vendaProduto"
            style={{ width: '100%', maxWidth: '800px', padding: '30px 0' }} 
            onSubmit={handleSubmit}
          >
            
            {/* Produto Selecionado */}
            <div id="venda-prod-secao-produto" style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#fff3e0', borderRadius: '8px', border: '1px solid #ffcc02' }}>
              <label style={{ color: 'rgb(184, 98, 0)', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                📦 Produto Selecionado:
              </label>
              <div style={{ color: '#333', fontWeight: '500' }}>
                {produtoSelecionado?.nome} (ID: {produtoSelecionado?.id})
              </div>
              <div style={{ color: '#666', fontSize: '14px', marginTop: '4px' }}>
                Estoque disponível: {produtoSelecionado?.estoque || 0} unidades • Preço: R$ {produtoSelecionado?.preco?.toFixed(2) || '0,00'}
              </div>
            </div>

            {/* Lista de itens (quando houver múltiplos produtos) */}
            {items && items.length > 0 && (
              <div className="venda-items-container" style={{ marginBottom: '16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                <label style={{ fontWeight: 'bold', color: '#333' }}>Itens da Venda</label>
                {items.map((it, idx) => (
                  <div key={it._uid || `${it.produtoId || it.ProdutoId || 'item'}-${idx}`} className="venda-item-row" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px', border: '1px solid #eee', borderRadius: 6 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="venda-item-nome" style={{ fontSize: 13, color: '#333', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{it.nome} (ID: {it.produtoId})</div>
                      {it.legislacao && <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Legislação: {it.legislacao}</div>}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <input
                        type="number"
                        value={it.precoUnitario}
                        step="0.01"
                        readOnly
                        placeholder="Preço"
                        className="venda-input-preco"
                        style={{ width: '70px', padding: '6px', borderRadius: 4, border: '1px solid #ddd', backgroundColor: '#f8f9fa', color: '#6c757d', fontSize: 13, height: '32px', boxSizing: 'border-box', cursor: 'not-allowed', textAlign: 'center' }}
                      />
                      <input
                        type="number"
                        value={it.quantidade}
                        min="1"
                        step="1"
                        onChange={e => {
                          const val = parseInt(e.target.value) || 1;
                          atualizarItemLocal(idx, { ...it, quantidade: val });
                          setTimeout(() => calcularTotal(), 50);
                        }}
                        placeholder="Qtd"
                        className="venda-input-quantidade"
                        style={{ width: '50px', padding: '6px 4px', borderRadius: 4, border: '1px solid #ddd', fontSize: 13, height: '32px', boxSizing: 'border-box', textAlign: 'center' }}
                      />
                      <button 
                        type="button" 
                        className="btn-qtd-menos"
                        onClick={() => {
                          const val = Math.max(1, (it.quantidade || 1) - 1);
                          atualizarItemLocal(idx, { ...it, quantidade: val });
                          setTimeout(() => calcularTotal(), 50);
                        }}
                        style={{ 
                          width: '28px', 
                          height: '28px', 
                          borderRadius: '50%', 
                          background: '#6c757d', 
                          color: 'white', 
                          border: 'none', 
                          cursor: 'pointer',
                          fontSize: '16px',
                          fontWeight: 'bold',
                          lineHeight: '1',
                          padding: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}
                      >
                        -
                      </button>
                      <button 
                        type="button"
                        className="btn-qtd-mais"
                        onClick={() => {
                          const val = (it.quantidade || 1) + 1;
                          atualizarItemLocal(idx, { ...it, quantidade: val });
                          setTimeout(() => calcularTotal(), 50);
                        }}
                        style={{ 
                          width: '28px', 
                          height: '28px', 
                          borderRadius: '50%', 
                          background: '#6c757d', 
                          color: 'white', 
                          border: 'none', 
                          cursor: 'pointer',
                          fontSize: '16px',
                          fontWeight: 'bold',
                          lineHeight: '1',
                          padding: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}
                      >
                        +
                      </button>
                    </div>
                    <button 
                      type="button" 
                      className="btn-remover-item"
                      onClick={() => { removerItemLocal(idx); setTimeout(() => calcularTotal(), 50); }} 
                      style={{ background: '#f44336', color: 'white', border: 'none', padding: 0, borderRadius: '50%', cursor: 'pointer', width: '28px', height: '28px', fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', flexShrink: 0, marginLeft: 'auto' }}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* Botão adicionar produtos (logo abaixo do container de valor total) */}
            <div className="venda-add-produto" style={{ display: 'flex', justifyContent: 'center', marginBottom: '18px' }}>
              <button
                type="button"
                onClick={() => {
                  if (typeof onAbrirPopupProdutos === 'function') {
                    onAbrirPopupProdutos();
                    return;
                  }
                  // fallback
                  console.log('Adicionar Produtos clicado (sem handler)');
                }}
                style={{
                  background: 'rgb(235, 133, 0)',
                  color: 'white',
                  border: 'none',
                  borderRadius: 6,
                  padding: '10px 18px',
                  fontSize: 14,
                  fontWeight: '600',
                  cursor: 'pointer',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.08)'
                }}
                onMouseEnter={e => e.target.style.background = 'rgb(208, 116, 0)'}
                onMouseLeave={e => e.target.style.background = 'rgb(235, 133, 0)'}
              >
                Adicionar Produtos
              </button>
            </div>

            {/* Cálculo dinâmico do valor total */}
            <div id="calculoTotal" className="venda-calculo-total" style={{ 
              marginBottom: '24px', 
              padding: '16px', 
              backgroundColor: '#e8f5e8', 
              borderRadius: '8px', 
              border: '1px solid #4caf50',
              textAlign: 'center'
            }}>
              <div style={{ color: '#2e7d32', fontWeight: 'bold', fontSize: '16px' }}>
                💰 Valor Total: R$ <span id="valorCalculado">0,00</span>
              </div>
              <div style={{ color: '#666', fontSize: '12px', marginTop: '4px' }}>
                (Preço × Quantidade) - Desconto + Juros + Impostos
              </div>
            </div>

            {/* Linha 1 removida: Preço Unitário e Quantidade agora são gerenciados por item (carrinho) */}

            {/* Informações da Entrega (fotos e observações) - aparece quando há entrega relacionada */}
            {vendaEdicao && (
              <div style={{ marginTop: 12, marginBottom: 20, padding: 16, borderRadius: 8, background: '#fafafa', border: '1px solid #eee' }}>
                <h4 style={{ marginTop: 0 }}>Informações da Entrega</h4>
                {entregaData ? (
                  <div>
                    <div style={{ marginBottom: 8 }}><strong>Status:</strong> {entregaData.Status || entregaData.status || '—'}</div>
                    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 12 }}>
                      {(entregaData.Fotos || entregaData.fotos || []).map((f, idx) => (
                        <div key={f.Id || f.id || idx} style={{ width: 120, textAlign: 'center' }}>
                          {/* tentar carregar via endpoint de download se existir */}
                          <img src={f.NomeArquivo ? `/api/EntregaProduto/${entregaData.Id || entregaData.id}/fotos/${f.Id || f.id}` : ''}
                            alt={f.NomeArquivo || f.nomeArquivo || 'foto'}
                            style={{ width: '100%', height: 80, objectFit: 'cover', borderRadius: 6, border: '1px solid #ddd' }}
                            onError={(e) => { e.target.src = ''; }}
                          />
                          <div style={{ fontSize: 12, marginTop: 4 }}>{f.NomeArquivo || f.nomeArquivo}</div>
                        </div>
                      ))}
                    </div>

                    <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                      <label style={{ display: 'inline-block', padding: '8px 12px', background: '#fff', border: '1px dashed #ccc', borderRadius: 6, cursor: 'pointer' }}>
                        Selecionar imagens
                        <input type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={e => handleSelectFiles(e.target.files)} />
                      </label>
                      <button type="button" onClick={handleUploadFotos} disabled={uploadingFotos || uploadFiles.length===0} style={{ background: '#1976d2', color: 'white', border: 'none', padding: '8px 12px', borderRadius: 6 }}>Enviar fotos</button>
                      {uploadingFotos && <span>Enviando...</span>}
                    </div>

                    {uploadPreviews && uploadPreviews.length > 0 && (
                      <div style={{ display: 'flex', gap: 12, marginTop: 12, flexWrap: 'wrap' }}>
                        {uploadPreviews.map((p, i) => (
                          <div key={i} style={{ width: 120 }}>
                            <img src={p.url} alt={p.name} style={{ width: '100%', height: 80, objectFit: 'cover', borderRadius: 6, border: '1px solid #ddd' }} />
                            <div style={{ fontSize: 12 }}>{p.name}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ color: '#666' }}>Nenhuma entrega registrada para esta venda.</div>
                )}
              </div>
            )}

            {/* Linha 2: Cliente e Vendedor */}
            <div className="venda-grid venda-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: '24px' }}>
              <div>
                <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Cliente:
                </label>
                {/* Custom Dropdown - Nome + CPF/CNPJ */}
                <div ref={clienteDropdownRef} style={{ position: 'relative', width: '100%' }}>
                  {/* Botão que mostra a seleção atual */}
                  <div
                    onClick={() => { if (!vendaAprovada) setClienteDropdownAberto(!clienteDropdownAberto); }}
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '5px',
                      border: '1px solid #ddd',
                      fontSize: '14px',
                      backgroundColor: vendaAprovada ? '#f5f5f5' : 'white',
                      cursor: vendaAprovada ? 'not-allowed' : 'pointer',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      boxSizing: 'border-box',
                      minHeight: '42px'
                    }}
                  >
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {(() => {
                        if (!clienteSelecionadoId || clienteSelecionadoId === 'outros') return 'Outros';
                        const cl = clientes.find(c => String(c.id || c.Id) === String(clienteSelecionadoId));
                        if (!cl) return 'Outros';
                        const nome = cl.nome || cl.Nome || '';
                        const cpf = cl.cpF_CNPJ || cl.CPF_CNPJ || cl.cpf_cnpj || '';
                        return cpf ? `${nome} — ${cpf}` : nome;
                      })()}
                    </span>
                    <span style={{ marginLeft: '8px', fontSize: '10px', color: '#888' }}>▼</span>
                  </div>

                  {/* Lista dropdown */}
                  {clienteDropdownAberto && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      maxHeight: '320px',
                      overflowY: 'auto',
                      border: '1px solid #ddd',
                      borderTop: 'none',
                      borderRadius: '0 0 5px 5px',
                      backgroundColor: '#fff',
                      zIndex: 9999,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                    }}>
                      {/* Campo de busca */}
                      <div style={{ padding: '8px', borderBottom: '1px solid #eee', position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                        <input
                          type="text"
                          placeholder="Buscar cliente..."
                          value={clienteBusca}
                          onChange={(e) => setClienteBusca(e.target.value)}
                          autoFocus
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '13px',
                            boxSizing: 'border-box'
                          }}
                        />
                      </div>

                      {/* Opção "Outros" */}
                      <div
                        onClick={() => handleClienteChange('outros')}
                        style={{
                          padding: '10px 12px',
                          cursor: 'pointer',
                          backgroundColor: clienteSelecionadoId === 'outros' || !clienteSelecionadoId ? '#f0f7ff' : '#fff',
                          borderBottom: '1px solid #e0e0e0'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = (clienteSelecionadoId === 'outros' || !clienteSelecionadoId) ? '#f0f7ff' : '#fff'}
                      >
                        <div style={{ fontWeight: '500', fontSize: '14px', color: '#333' }}>Outros</div>
                      </div>

                      {/* Lista de clientes */}
                      {[...clientes]
                        .sort((a, b) => ((a.nome || a.Nome || '').localeCompare((b.nome || b.Nome || ''), 'pt-BR')))
                        .filter(cliente => {
                          if (!clienteBusca.trim()) return true;
                          const termo = clienteBusca.toLowerCase();
                          const nome = (cliente.nome || cliente.Nome || '').toLowerCase();
                          const cpf = (cliente.cpF_CNPJ || cliente.CPF_CNPJ || cliente.cpf_cnpj || '').toLowerCase();
                          return nome.includes(termo) || cpf.includes(termo);
                        })
                        .map((cliente, idx, arr) => {
                          const id = String(cliente.id || cliente.Id);
                          const nome = cliente.nome || cliente.Nome || '';
                          const cpfCnpj = cliente.cpF_CNPJ || cliente.CPF_CNPJ || cliente.cpf_cnpj || '';
                          const selecionado = String(clienteSelecionadoId) === id;
                          return (
                            <div
                              key={id}
                              onClick={() => handleClienteChange(id)}
                              style={{
                                padding: '10px 12px',
                                cursor: 'pointer',
                                backgroundColor: selecionado ? '#f0f7ff' : '#fff',
                                borderBottom: idx < arr.length - 1 ? '1px solid #e0e0e0' : 'none'
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selecionado ? '#f0f7ff' : '#fff'}
                            >
                              <div style={{ fontWeight: '500', fontSize: '14px', color: '#333' }}>{nome}</div>
                              {cpfCnpj && (
                                <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>
                                  CPF/CNPJ: {cpfCnpj}
                                </div>
                              )}
                            </div>
                          );
                        })
                      }
                    </div>
                  )}
                </div>
              </div>
              <div>
                <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Vendedor:
                </label>
                {/* Custom Dropdown - Nome + ID (mesmo padrão do Cliente) */}
                <div ref={vendedorDropdownRef} style={{ position: 'relative', width: '100%' }}>
                  {/* Botão que mostra a seleção atual */}
                  <div
                    onClick={() => { if (!vendaAprovada) setVendedorDropdownAberto(!vendedorDropdownAberto); }}
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '5px',
                      border: '1px solid #ddd',
                      fontSize: '14px',
                      backgroundColor: vendaAprovada ? '#f5f5f5' : 'white',
                      cursor: vendaAprovada ? 'not-allowed' : 'pointer',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      boxSizing: 'border-box',
                      minHeight: '42px'
                    }}
                  >
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {(() => {
                        if (!vendedorSelecionadoId) return 'Selecione um vendedor';
                        const vd = vendedores.find(v => String(v.id || v.Id) === String(vendedorSelecionadoId));
                        if (!vd) return 'Selecione um vendedor';
                        const nome = vd.nome || vd.Nome || '';
                        const id = vd.id || vd.Id;
                        return `${nome} (ID: ${id})`;
                      })()}
                    </span>
                    <span style={{ marginLeft: '8px', fontSize: '10px', color: '#888' }}>▼</span>
                  </div>

                  {/* Lista dropdown */}
                  {vendedorDropdownAberto && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      maxHeight: '320px',
                      overflowY: 'auto',
                      border: '1px solid #ddd',
                      borderTop: 'none',
                      borderRadius: '0 0 5px 5px',
                      backgroundColor: '#fff',
                      zIndex: 9999,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                    }}>
                      {/* Campo de busca */}
                      <div style={{ padding: '8px', borderBottom: '1px solid #eee', position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                        <input
                          type="text"
                          placeholder="Buscar vendedor..."
                          value={vendedorBusca}
                          onChange={(e) => setVendedorBusca(e.target.value)}
                          autoFocus
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '13px',
                            boxSizing: 'border-box'
                          }}
                        />
                      </div>

                      {/* Opção "Nenhum" */}
                      <div
                        onClick={() => handleVendedorChange('')}
                        style={{
                          padding: '10px 12px',
                          cursor: 'pointer',
                          backgroundColor: !vendedorSelecionadoId ? '#f0f7ff' : '#fff',
                          borderBottom: '1px solid #e0e0e0'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = !vendedorSelecionadoId ? '#f0f7ff' : '#fff'}
                      >
                        <div style={{ fontWeight: '500', fontSize: '14px', color: '#333' }}>Selecione um vendedor</div>
                      </div>

                      {/* Lista de vendedores */}
                      {[...vendedores]
                        .sort((a, b) => ((a.nome || a.Nome || '').localeCompare((b.nome || b.Nome || ''), 'pt-BR')))
                        .filter(vendedor => {
                          if (!vendedorBusca.trim()) return true;
                          const termo = vendedorBusca.toLowerCase();
                          const nome = (vendedor.nome || vendedor.Nome || '').toLowerCase();
                          const id = String(vendedor.id || vendedor.Id || '').toLowerCase();
                          return nome.includes(termo) || id.includes(termo);
                        })
                        .map((vendedor, idx, arr) => {
                          const id = String(vendedor.id || vendedor.Id);
                          const nome = vendedor.nome || vendedor.Nome || '';
                          const selecionado = String(vendedorSelecionadoId) === id;
                          return (
                            <div
                              key={id}
                              onClick={() => handleVendedorChange(id)}
                              style={{
                                padding: '10px 12px',
                                cursor: 'pointer',
                                backgroundColor: selecionado ? '#f0f7ff' : '#fff',
                                borderBottom: idx < arr.length - 1 ? '1px solid #e0e0e0' : 'none'
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selecionado ? '#f0f7ff' : '#fff'}
                            >
                              <div style={{ fontWeight: '500', fontSize: '14px', color: '#333' }}>{nome}</div>
                              <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>
                                ID: {id}
                              </div>
                            </div>
                          );
                        })
                      }
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Linha 3: Datas */}
            <div className="venda-grid venda-grid-3" style={{ display: 'grid', gridTemplateColumns: '150px 200px 1fr', gap: '30px', marginBottom: '24px' }}>
              <div>
                <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Data da Venda:
                </label>
                <input
                  name="dataVenda"
                  type="date"
                  defaultValue={new Date().toISOString().split('T')[0]}
                  required
                  disabled={vendaAprovada}
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    backgroundColor: vendaAprovada ? '#f5f5f5' : 'white',
                    cursor: vendaAprovada ? 'not-allowed' : 'text'
                  }}
                />
              </div>
              <div>
                <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px', whiteSpace: 'nowrap' }}>
                  Data Entrega Programada:
                </label>
                <input
                  name="dataEntrega"
                  type="date"
                  min={new Date().toISOString().split('T')[0]}
                  disabled={vendaAprovada}
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    backgroundColor: vendaAprovada ? '#f5f5f5' : 'white',
                    cursor: vendaAprovada ? 'not-allowed' : 'text'
                  }}
                />
              </div>
              <div></div>
            </div>

            {/* Linha 4: Status e Pagamento */}
            <div id="venda-prod-secao-pagamento" className="venda-grid venda-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: '24px' }}>
              <div>
                <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Status da Venda:
                </label>
                <select
                  name="statusVenda"
                  disabled={vendaAprovada}
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    backgroundColor: vendaAprovada ? '#f5f5f5' : 'white',
                    cursor: vendaAprovada ? 'not-allowed' : 'pointer'
                  }}
                >
                  <option value="Pendente">Pendente</option>
                  <option value="Em Análise">Em Análise</option>
                  <option value="Aprovada">Aprovada</option>
                  <option value="Cancelada">Cancelada</option>
                </select>
              </div>
              <div>
                <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Tipo de Pagamento:
                </label>
                {/* Não editável: o tipo vem do meio que o cliente usou no Stripe */}
                <select
                  name="tipoPagamentoId"
                  value={tipoPagamentoSelecionado || ''}
                  onChange={handleTipoPagamentoChange}
                  disabled
                  title="Definido automaticamente pelo Stripe"
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed'
                  }}
                >
                  <option value="">Aguardando pagamento no Stripe</option>
                  {tiposPagamento.map(tipo => {
                    const descricao = tipo.descricaoPagamento || tipo.DescricaoPagamento || tipo.nome || tipo.Nome || tipo.descricao || tipo.Descricao || `Tipo ${tipo.id || tipo.Id}`;
                    return (
                      <option key={tipo.id || tipo.Id} value={tipo.id || tipo.Id}>
                        {descricao}
                      </option>
                    );
                  })}
                </select>
                <div style={{ fontSize: 12, color: '#777', marginTop: 4 }}>Definido automaticamente pelo meio usado no Stripe (Pix, boleto ou cartão).</div>
              </div>
            </div>

            {/* Seção de Configuração de Pagamento */}
            {tipoPagamentoSelecionado && (
              <div style={{ marginBottom: '24px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                {/* Container de Dados do Cartão (posicionado acima do título, igual ao VendasDropdown) */}
                {isCardPaymentType() && (
                  <div style={{padding:'12px 16px', background:'#e3f2fd', borderRadius:8, marginBottom:12, fontSize:13, color:'#1565c0', border:'1px solid #90caf9'}}>
                    💳 O pagamento por cartão será processado pela página segura do Stripe ao clicar em <strong>Realizar Pagamento</strong>.
                  </div>
                )}
                <h4 style={{marginTop:0, color:'#333'}}>Configuração de Pagamento</h4>
                {configuracoesFiltradas.length === 0 ? (
                  <div style={{color:'#a00', fontSize:'14px'}}>Nenhuma configuração ativa para este tipo de pagamento.</div>
                ) : (
                  <div className="venda-config-grid" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'25px' }}>
                    <div>
                      <label style={{display:'block', fontWeight:500, marginBottom:4}}>Configuração</label>
                      <select
                        value={configuracaoSelecionadaId || ''}
                        onChange={handleConfiguracaoChange}
                        style={{width:'100%', padding:'8px', border:'1px solid #ddd', borderRadius:'4px'}}
                      >
                        <option value=''>Selecione</option>
                        {configuracoesFiltradas.map(cfg => {
                          const label = (cfg.descricaoCompleta || cfg.DescricaoCompleta) || 
                            [
                              cfg.tipoPagamentoDescricao || cfg.TipoPagamentoDescricao,
                              cfg.modalidadePagamentoDescricao || cfg.ModalidadePagamentoDescricao,
                              cfg.configuracaoJurosDescricao || cfg.ConfiguracaoJurosDescricao,
                              cfg.tipoJuros || cfg.TipoJuros ? `(${(cfg.tipoJuros||cfg.TipoJuros)}${cfg.valorJuros||cfg.ValorJuros ? ':'+ (cfg.valorJuros||cfg.ValorJuros) : ''})` : null
                            ].filter(Boolean).join(' ');
                          return (
                            <option key={cfg.id || cfg.Id} value={cfg.id || cfg.Id}>
                              {label.trim() || `Configuração #${cfg.id || cfg.Id}`}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {configuracaoSelecionadaId && (() => {
                      const cfg = configuracoesPagamento.find(c => (c.id || c.Id) === configuracaoSelecionadaId);
                      if (!cfg) return null;
                      const maxParcelas = cfg.maximoParcelas || cfg.MaximoParcelas || 1;
                      const descricaoJuros = cfg.configuracaoJurosDescricao || cfg.ConfiguracaoJurosDescricao;
                      const temJuros = (descricaoJuros||'').toUpperCase().includes('COM');
                      const modalidade = cfg.modalidadePagamentoDescricao || cfg.ModalidadePagamentoDescricao || '';
                      const isAVista = modalidade.toUpperCase().includes('VISTA');
                      return (
                        <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
                          <div style={{fontSize:'13px', color:'#444'}}>
                            <strong>Modalidade:</strong> {modalidade || '—'}<br/>
                            <strong>Juros:</strong> {descricaoJuros || '—'} {temJuros && (<>
                              | Tipo: {cfg.tipoJuros || cfg.TipoJuros || '—'}
                              {cfg.valorJuros ? ` | Valor: ${(cfg.tipoJuros||cfg.TipoJuros||'').toUpperCase()==='PERCENTUAL' ? (cfg.valorJuros || cfg.ValorJuros)+'%' : 'R$ '+(cfg.valorJuros||cfg.ValorJuros)}` : ''}
                            </>)}<br/>
                            <strong>Máx Parcelas:</strong> {maxParcelas}<br/>
                            {cfg.valorMinimoParcela || cfg.ValorMinimoParcela ? <><strong>Parcela Mínima:</strong> R$ {(cfg.valorMinimoParcela || cfg.ValorMinimoParcela).toFixed ? (cfg.valorMinimoParcela || cfg.ValorMinimoParcela).toFixed(2) : (cfg.valorMinimoParcela || cfg.ValorMinimoParcela)}</> : null}
                          </div>
                          {!isAVista && (
                            <div style={{display:'flex', gap:'15px'}}>
                              <div>
                                <label style={{display:'block', fontSize:13, marginBottom:4}}>Qtd Parcelas</label>
                                <input type='number' min={1} max={maxParcelas}
                                  value={quantidadeParcelas}
                                  onChange={e=> setQuantidadeParcelas(Math.min(parseInt(e.target.value)||1, maxParcelas))}
                                  style={{padding:'6px', border:'1px solid #ccc', borderRadius:4, width:'120px'}} />
                              </div>
                              <div>
                                <label style={{display:'block', fontSize:13, marginBottom:4}}>1º Vencimento</label>
                                <input type='date'
                                  value={dataInicioVencimento}
                                  onChange={e=> setDataInicioVencimento(e.target.value)}
                                  style={{padding:'6px', border:'1px solid #ccc', borderRadius:4}} />
                              </div>
                            </div>
                          )}
                          {/* ...existing code... (Dados do Cartão movidos acima do título de Configuração) */}
                          {/* Inputs manuais de Juros */}
                          {temJuros && (
                            <div style={{display:'flex', gap:'15px', flexWrap:'wrap'}}>
                              <div>
                                <label style={{display:'block', fontSize:13, marginBottom:4}}>Tipo de Juros</label>
                                <select
                                  value={tipoJurosUI}
                                  onChange={e => {
                                    const val = e.target.value;
                                    setTipoJurosUI(val);
                                    
                                    // Atualizar configuração
                                    if (val === 'SEM_JUROS') {
                                      cfg.tipoJuros = 'ABSOLUTO';
                                      cfg.valorJuros = 0;
                                      cfg.TipoJuros = 'ABSOLUTO';
                                      cfg.ValorJuros = 0;
                                    } else {
                                      cfg.tipoJuros = val;
                                      cfg.TipoJuros = val;
                                    }
                                    
                                    setConfiguracoesPagamento([...configuracoesPagamento]);
                                    
                                    // Executar recálculo automático
                                    setTimeout(() => {
                                      const form = document.querySelector('form[data-calculo="vendaProduto"]');
                                      if (form && produtoSelecionado) {
                                        const preco = parseFloat(produtoSelecionado?.preco || 0);
                                        const quantidade = parseInt(form.quantidade?.value || 1);
                                        const desconto = parseFloat(form.desconto?.value || 0);
                                        const impostos = parseFloat(form.impostos?.value || 0);
                                        
                                        const valorBase = (preco * quantidade) - desconto + impostos;
                                        executarCalculoPagamento(Math.max(0, valorBase));
                                      }
                                    }, 100);
                                  }}
                                  style={{padding:'6px', border:'1px solid #ccc', borderRadius:4}}
                                >
                                  <option value=''>Selecione</option>
                                  <option value='SEM_JUROS'>Sem Juros</option>
                                  <option value='ABSOLUTO'>Absoluto (R$)</option>
                                  <option value='PERCENTUAL'>Percentual (%)</option>
                                </select>
                              </div>
                              <div>
                                <label style={{display:'block', fontSize:13, marginBottom:4}}>Valor Juros (R$)</label>
                                <input
                                  type='number'
                                  step='0.01'
                                  min='0'
                                  value={tipoJurosUI === 'SEM_JUROS' ? 0 : ((cfg.valorJuros || cfg.ValorJuros) ?? '')}
                                  onChange={e => {
                                    if (tipoJurosUI === 'SEM_JUROS') return;
                                    const v = parseFloat(e.target.value);
                                    if (!isNaN(v)) {
                                      cfg.valorJuros = v;
                                      cfg.ValorJuros = v;
                                    } else {
                                      cfg.valorJuros = null;
                                      cfg.ValorJuros = null;
                                    }
                                    setConfiguracoesPagamento([...configuracoesPagamento]);
                                    
                                    // Executar recálculo automático
                                    setTimeout(() => {
                                      const form = document.querySelector('form[data-calculo="vendaProduto"]');
                                      if (form && produtoSelecionado) {
                                        const preco = parseFloat(produtoSelecionado?.preco || 0);
                                        const quantidade = parseInt(form.quantidade?.value || 1);
                                        const desconto = parseFloat(form.desconto?.value || 0);
                                        const impostos = parseFloat(form.impostos?.value || 0);
                                        
                                        const valorBase = (preco * quantidade) - desconto + impostos;
                                        executarCalculoPagamento(Math.max(0, valorBase));
                                      }
                                    }, 300);
                                  }}
                                  disabled={tipoJurosUI === 'SEM_JUROS'}
                                  placeholder="R$ 0,00"
                                  style={{padding:'6px', border:'1px solid #ccc', borderRadius:4, width:'120px', background: tipoJurosUI==='SEM_JUROS' ? '#eee' : '#fff'}}
                                />
                              </div>
                              <div style={{alignSelf:'flex-end', fontSize:12, color:'#555'}}>
                                {tipoJurosUI === 'SEM_JUROS' ? '(Sem juros aplicados)' : '(Ajuste local – cálculo backend só após Aprovar)'}
                              </div>
                            </div>
                          )}
                          {erroCalculo && <div style={{color:'#b00020', fontSize:'13px'}}>{erroCalculo}</div>}
                          {(() => {
                            return (
                              <div style={{marginTop:'10px', fontSize:'13px', background:'#fff', padding:'12px', border:'1px solid #e0e0e0', borderRadius:6}}>
                                {calculoPagamento ? (
                                  <>
                                    <strong>Resultado:</strong><br/>
                                    Valor Original: R$ {calculoPagamento.valorOriginal?.toFixed(2)}<br/>
                                    Juros: R$ {calculoPagamento.valorJuros?.toFixed(2)}<br/>
                                    Valor Final: <span style={{color:'#0a7d24', fontWeight:600}}>R$ {calculoPagamento.valorFinal?.toFixed(2)}</span><br/>
                                    Parcelas: {calculoPagamento.quantidadeParcelas}x de R$ {calculoPagamento.valorParcela?.toFixed(2)}<br/>
                                    {calculoPagamento.observacaoCalculo && <em>{calculoPagamento.observacaoCalculo}</em>}
                                    {calculoPagamento.parcelas && calculoPagamento.parcelas.length > 0 && (
                                      <table style={{width:'100%', marginTop:'10px', borderCollapse:'collapse', fontSize:'12px'}}>
                                        <thead>
                                          <tr style={{background:'#f0f0f0'}}>
                                            <th style={{border:'1px solid #ddd', padding:4}}>Parcela</th>
                                            <th style={{border:'1px solid #ddd', padding:4}}>Valor</th>
                                            <th style={{border:'1px solid #ddd', padding:4}}>Vencimento</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {calculoPagamento.parcelas.map(p => (
                                            <tr key={p.numeroParcela}>
                                              <td style={{border:'1px solid #eee', padding:4}}>{p.numeroParcela}</td>
                                              <td style={{border:'1px solid #eee', padding:4}}>R$ {p.valorParcela?.toFixed(2)}</td>
                                              <td style={{border:'1px solid #eee', padding:4}}>{new Date(p.dataVencimento).toLocaleDateString()}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    )}
                                  </>
                                ) : (
                                  <div style={{color:'#666', fontStyle:'italic'}}>
                                    {configuracaoSelecionadaId ? 'Aguardando cálculo...' : ''}
                                  </div>
                                )}
                              </div>
                            );
                          })()}
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
            )}

            {/* Linha 5: Valores e Cálculos */}
            <div className="venda-grid venda-grid-4" style={{ display: 'grid', gridTemplateColumns: '140px 120px 1fr 1fr', gap: '18px', marginBottom: '24px', alignItems: 'end' }}>
              <div>
                <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                  Desconto (R$):
                </label>
                <input
                  name="desconto"
                  type="number"
                  step="0.01"
                  min="0"
                  defaultValue="0"
                  disabled={vendaAprovada}
                  onChange={calcularTotal}
                  placeholder="R$ 0,00"
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    backgroundColor: vendaAprovada ? '#f5f5f5' : 'white',
                    cursor: vendaAprovada ? 'not-allowed' : 'text'
                  }}
                />
              </div>
            </div>

            {/* Observações */}
            <div style={{ marginBottom: '30px' }}>
              <label style={{ color: '#333', fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
                Observações:
              </label>
              <textarea
                name="notas"
                rows="3"
                disabled={vendaAprovada}
                placeholder="Observações adicionais sobre a venda..."
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ddd',
                  fontSize: '14px',
                  backgroundColor: vendaAprovada ? '#f5f5f5' : 'white',
                  cursor: vendaAprovada ? 'not-allowed' : 'text',
                  resize: 'vertical'
                }}
              />
            </div>

            {/* ==================== DADOS DO COMPRADOR (NF-e) ==================== */}
            <div id="venda-prod-secao-comprador" style={{ marginBottom: '24px', borderRadius: '10px', border: '1px solid #90caf9', overflow: 'hidden' }}>
              {/* Header toggle */}
              <div
                style={{ padding: '14px 20px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: mostrarDadosComprador ? '#1565c0' : '#1976d2', color: 'white', userSelect: 'none' }}
                onClick={() => setMostrarDadosComprador(p => !p)}
              >
                <span style={{ fontWeight: 'bold', fontSize: '15px' }}>🧾 Dados do Comprador (NF-e)</span>
                <span style={{ fontSize: '18px' }}>{mostrarDadosComprador ? '▲' : '▼'}</span>
              </div>

              {!mostrarDadosComprador && (
                <div style={{ padding: '12px 20px', fontSize: '13px', color: '#555', background: '#e3f2fd' }}>
                  ℹ️ Opcional — sem esses dados a venda será registrada normalmente, mas <strong>não será possível emitir Nota Fiscal</strong>.
                  {' '}<span style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => setMostrarDadosComprador(true)}>Preencher agora</span>
                </div>
              )}

              {mostrarDadosComprador && (
                <div style={{ padding: '20px', background: '#f0f7ff' }}>
                  <p style={{ color: 'rgb(184, 98, 0)', fontSize: '13px', background: '#fff3e0', padding: '10px 14px', borderRadius: '6px', margin: '0 0 18px 0' }}>
                    ⚠️ Nenhum campo é obrigatório para salvar a venda. Campos com <strong>*</strong> são necessários apenas para emissão da NF-e. Você pode preenchê-los depois em Nota Fiscal.
                  </p>

                  {/* Tipo + Documento + Nome */}
                  <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr 1fr', gap: '14px', marginBottom: '14px' }}>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Tipo *</label>
                      <select value={dadosComprador.tipoDocumento}
                        onChange={e => setDadosComprador(p => ({ ...p, tipoDocumento: e.target.value, numeroDocumento: '' }))}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px' }}>
                        <option value="CPF">CPF (Pessoa Física)</option>
                        <option value="CNPJ">CNPJ (Pessoa Jurídica)</option>
                      </select>
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>
                        {dadosComprador.tipoDocumento === 'CNPJ' ? 'CNPJ *' : 'CPF *'}
                      </label>
                      <input type="text" value={dadosComprador.numeroDocumento}
                        onChange={e => setDadosComprador(p => ({ ...p, numeroDocumento: e.target.value.replace(/\D/g, '') }))}
                        maxLength={dadosComprador.tipoDocumento === 'CNPJ' ? 14 : 11}
                        placeholder={dadosComprador.tipoDocumento === 'CNPJ' ? '14 dígitos' : '11 dígitos'}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>
                        {dadosComprador.tipoDocumento === 'CNPJ' ? 'Razão Social *' : 'Nome Completo *'}
                      </label>
                      <input type="text" value={dadosComprador.nomeRazaoSocial}
                        onChange={e => setDadosComprador(p => ({ ...p, nomeRazaoSocial: e.target.value }))}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                  </div>

                  {/* Logradouro + Número + Complemento */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 100px 1fr', gap: '14px', marginBottom: '14px' }}>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Logradouro *</label>
                      <input type="text" value={dadosComprador.logradouro}
                        onChange={e => setDadosComprador(p => ({ ...p, logradouro: e.target.value }))}
                        placeholder="Rua, Av.…"
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Número *</label>
                      <input type="text" value={dadosComprador.numero}
                        onChange={e => setDadosComprador(p => ({ ...p, numero: e.target.value }))}
                        placeholder="S/N"
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Complemento</label>
                      <input type="text" value={dadosComprador.complemento}
                        onChange={e => setDadosComprador(p => ({ ...p, complemento: e.target.value }))}
                        placeholder="Apto, sala…"
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                  </div>

                  {/* Bairro + Município + UF + CEP */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 80px 120px', gap: '14px', marginBottom: '14px' }}>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Bairro *</label>
                      <input type="text" value={dadosComprador.bairro}
                        onChange={e => setDadosComprador(p => ({ ...p, bairro: e.target.value }))}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Município *</label>
                      <input type="text" value={dadosComprador.nomeMunicipio}
                        onChange={e => setDadosComprador(p => ({ ...p, nomeMunicipio: e.target.value }))}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>UF *</label>
                      <select value={dadosComprador.uf}
                        onChange={e => setDadosComprador(p => ({ ...p, uf: e.target.value }))}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px' }}>
                        <option value="">--</option>
                        {['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'].map(uf => (
                          <option key={uf} value={uf}>{uf}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>CEP *</label>
                      <input type="text" value={(dadosComprador.cep || '').replace(/^(\d{5})(\d)/, '$1-$2')}
                        onChange={e => setDadosComprador(p => ({ ...p, cep: e.target.value.replace(/\D/g, '').slice(0, 8) }))}
                        maxLength={10} placeholder="00000-000"
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                  </div>

                  {/* Cód. IBGE + Telefone + E-mail */}
                  <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr 1fr', gap: '14px', marginBottom: '14px' }}>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Cód. IBGE *</label>
                      <input type="text" value={dadosComprador.codigoMunicipioIBGE}
                        onChange={e => setDadosComprador(p => ({ ...p, codigoMunicipioIBGE: e.target.value.replace(/\D/g, '') }))}
                        maxLength={7} placeholder="7 dígitos"
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Telefone</label>
                      <input type="text" value={dadosComprador.telefone}
                        onChange={e => setDadosComprador(p => ({ ...p, telefone: e.target.value }))}
                        placeholder="(11) 99999-9999"
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>E-mail</label>
                      <input type="email" value={dadosComprador.email}
                        onChange={e => setDadosComprador(p => ({ ...p, email: e.target.value }))}
                        placeholder="comprador@email.com"
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box' }} />
                    </div>
                  </div>

                  {/* Dados fiscais do comprador */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '14px', marginBottom: '14px' }}>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Indicador IE</label>
                      <select value={dadosComprador.indicadorIE}
                        onChange={e => setDadosComprador(p => ({ ...p, indicadorIE: e.target.value }))}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px' }}>
                        <option value="9">9 – Não contribuinte</option>
                        <option value="1">1 – Contribuinte ICMS</option>
                        <option value="2">2 – Isento de IE</option>
                      </select>
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Inscrição Estadual</label>
                      <input type="text" value={dadosComprador.inscricaoEstadual}
                        disabled={dadosComprador.indicadorIE !== '1'}
                        onChange={e => setDadosComprador(p => ({ ...p, inscricaoEstadual: e.target.value }))}
                        placeholder={dadosComprador.indicadorIE !== '1' ? 'N/A' : 'Número da IE'}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px', boxSizing: 'border-box', background: dadosComprador.indicadorIE !== '1' ? '#f5f5f5' : 'white' }} />
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Regime Tributário</label>
                      <select value={dadosComprador.regimeTributario}
                        onChange={e => setDadosComprador(p => ({ ...p, regimeTributario: e.target.value }))}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px' }}>
                        <option value="SIMPLES">Simples Nacional</option>
                        <option value="MEI">MEI</option>
                        <option value="PRESUMIDO">Lucro Presumido</option>
                        <option value="REAL">Lucro Real</option>
                      </select>
                    </div>
                    <div>
                      <label style={{ fontWeight: 'bold', fontSize: '13px', display: 'block', marginBottom: '6px', color: '#333' }}>Presença do Comprador</label>
                      <select value={dadosComprador.presencaComprador}
                        onChange={e => setDadosComprador(p => ({ ...p, presencaComprador: e.target.value }))}
                        style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', fontSize: '13px' }}>
                        <option value="1">1 – Presencial</option>
                        <option value="2">2 – Internet</option>
                        <option value="3">3 – Teleatendimento</option>
                        <option value="9">9 – Outros</option>
                      </select>
                    </div>
                  </div>

                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', color: '#333' }}>
                    <input type="checkbox" checked={dadosComprador.consumidorFinal}
                      onChange={e => setDadosComprador(p => ({ ...p, consumidorFinal: e.target.checked }))}
                      style={{ width: '16px', height: '16px', accentColor: '#1976d2' }} />
                    <strong>Consumidor Final</strong> — marque se o comprador é o destinatário final do produto
                  </label>
                </div>
              )}
            </div>

            {/* ========================================== */}
            {/* SEÇÃO DE PAGAMENTO STRIPE - Aparece quando venda está aprovada */}
            {/* ========================================== */}
            {(() => {
              const vendaAprovadaAtual = vendaAtual && 
                (vendaAtual.statusVenda === 'Aprovada' || vendaAtual.StatusVenda === 'Aprovada');
              const vendaAprovadaEdicao = vendaEdicao && 
                (vendaEdicao.statusVenda === 'Aprovada' || vendaEdicao.StatusVenda === 'Aprovada');
              const mostrarPagamento = vendaAprovadaAtual || vendaAprovadaEdicao;
              const idVendaPagamento = vendaAtual?.id || vendaAtual?.Id || vendaEdicao?.id || vendaEdicao?.Id;
              
              if (!mostrarPagamento || !idVendaPagamento) return null;
              
              const statusPag = statusPagamentoVenda || vendaAtual?.statusPagamento || vendaAtual?.StatusPagamento || 
                                vendaEdicao?.statusPagamento || vendaEdicao?.StatusPagamento || 'pending';
              const isPago = statusPag === 'paid' || statusPag === 'Pago';
              const isPendente = statusPag === 'pending' || statusPag === 'Pendente' || !statusPag;
              
              return (
                <div style={{
                  marginBottom: '30px',
                  padding: '20px',
                  backgroundColor: isPago ? '#e8f5e9' : '#fff3e0',
                  borderRadius: '10px',
                  border: isPago ? '2px solid #4caf50' : '2px solid rgb(235, 133, 0)',
                  textAlign: 'center'
                }}>
                  {/* Status do Pagamento */}
                  <div style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    marginBottom: '16px',
                    color: isPago ? '#2e7d32' : 'rgb(184, 98, 0)'
                  }}>
                    {isPago ? (
                      <>✅ PAGAMENTO REALIZADO</>
                    ) : (
                      <>⏳ PAGAMENTO PENDENTE</>
                    )}
                  </div>
                  
                  {isPendente && (
                    <>
                      <p style={{ color: '#666', marginBottom: '16px', fontSize: '14px' }}>
                        Clique no botão abaixo para abrir o checkout do Stripe e realizar o pagamento.
                        O valor será enviado para a conta bancária cadastrada.
                      </p>
                      
                      <button
                        type="button"
                        onClick={handleRealizarPagamento}
                        disabled={processandoPagamento}
                        style={{
                          background: processandoPagamento ? '#ccc' : 'linear-gradient(135deg, #635bff 0%, #7c3aed 100%)',
                          color: 'white',
                          border: 'none',
                          padding: '16px 32px',
                          borderRadius: '8px',
                          cursor: processandoPagamento ? 'not-allowed' : 'pointer',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          boxShadow: '0 4px 12px rgba(99, 91, 255, 0.4)',
                          transition: 'all 0.3s ease',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '10px'
                        }}
                        onMouseEnter={(e) => !processandoPagamento && (e.target.style.transform = 'translateY(-2px)')}
                        onMouseLeave={(e) => !processandoPagamento && (e.target.style.transform = 'translateY(0)')}
                      >
                        {processandoPagamento ? (
                          <>⏳ Processando...</>
                        ) : (
                          <>💳 Realizar Pagamento</>
                        )}
                      </button>

                      <p style={{ color: '#888', marginTop: '16px', fontSize: '12px' }}>
                        Powered by <strong>Stripe</strong> - Pagamento seguro
                      </p>
                    </>
                  )}
                  
                  {isPago && (
                    <p style={{ color: '#2e7d32', fontSize: '14px' }}>
                      O pagamento desta venda foi confirmado com sucesso!
                    </p>
                  )}
                </div>
              );
            })()}

            {/* Botões */}
            <div className="venda-form-actions" style={{ display: 'flex', gap: '16px', justifyContent: 'flex-end', paddingTop: '24px', borderTop: '1px solid #eee', flexWrap: 'wrap' }}>
              {vendaAprovada && (
                <button
                  type="button"
                  onClick={() => setPopupCancelarVenda(true)}
                  style={{
                    background: '#d32f2f',
                    color: 'white',
                    border: 'none',
                    padding: '12px 24px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    marginRight: 'auto',
                  }}
                >
                  🚫 Cancelar Venda
                </button>
              )}
              {vendaAprovada && (
                <button
                  type="button"
                  onClick={handleAbrirPopupPagamento}
                  disabled={processandoConfirmarPagamento}
                  style={{
                    background: processandoConfirmarPagamento ? '#ccc' : 'linear-gradient(135deg, #635bff 0%, #7c3aed 100%)',
                    color: 'white',
                    border: 'none',
                    padding: '12px 24px',
                    borderRadius: '6px',
                    cursor: processandoConfirmarPagamento ? 'not-allowed' : 'pointer',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: processandoConfirmarPagamento ? 'none' : '0 2px 8px rgba(99,91,255,0.4)',
                    transition: 'all 0.2s ease',
                  }}
                >
                  {processandoConfirmarPagamento ? '⏳ Processando...' : '💳 Realizar Pagamento'}
                </button>
              )}
              <button
                type="submit"
                disabled={vendaAprovada}
                style={{
                  background: vendaAprovada ? '#ccc' : 'rgb(235, 133, 0)',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '6px',
                  cursor: vendaAprovada ? 'not-allowed' : 'pointer',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  boxShadow: vendaAprovada ? 'none' : '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => !vendaAprovada && (e.target.style.backgroundColor = 'rgb(208, 116, 0)')}
                onMouseLeave={(e) => !vendaAprovada && (e.target.style.backgroundColor = 'rgb(235, 133, 0)')}
              >
                {vendaEdicao ? 'Salvar Alterações' : 'Criar Venda'}
              </button>
              <button
                type="button"
                onClick={onCancelar}
                style={{
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#5a6268'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#6c757d'}
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* ===== POPUP CONFIRMAÇÃO PAGAMENTO STRIPE ===== */}
      {showPopupPagamento && (
        <div
          onClick={() => !processandoConfirmarPagamento && setShowPopupPagamento(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 12, padding: '32px 28px', maxWidth: 540, width: '92%', boxShadow: '0 8px 32px rgba(0,0,0,0.25)', maxHeight: '88vh', overflowY: 'auto' }}
          >
            <div style={{ fontSize: 36, textAlign: 'center', marginBottom: 8 }}>💳</div>
            <h3 style={{ margin: '0 0 6px', color: '#1a237e', textAlign: 'center', fontSize: 20 }}>Confirmar Pagamento</h3>
            <p style={{ color: '#555', textAlign: 'center', marginBottom: 20, fontSize: 14 }}>
              Revise os itens e o valor total antes de prosseguir ao Stripe:
            </p>

            {/* Tabela de itens */}
            <div style={{ border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden', marginBottom: 16 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#f5f5f5' }}>
                    <th style={{ padding: '10px 12px', textAlign: 'left', color: '#333', fontWeight: 600 }}>Produto</th>
                    <th style={{ padding: '10px 8px', textAlign: 'center', color: '#333', fontWeight: 600 }}>Qtd</th>
                    <th style={{ padding: '10px 8px', textAlign: 'right', color: '#333', fontWeight: 600, whiteSpace: 'nowrap' }}>Preço Unit.</th>
                    <th style={{ padding: '10px 12px', textAlign: 'right', color: '#333', fontWeight: 600 }}>Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  {itensPopupPagamento.map((it, idx) => (
                    <tr key={idx} style={{ borderTop: '1px solid #eee' }}>
                      <td style={{ padding: '10px 12px', color: '#333' }}>{it.nome}</td>
                      <td style={{ padding: '10px 8px', textAlign: 'center', color: '#555' }}>{it.quantidade}</td>
                      <td style={{ padding: '10px 8px', textAlign: 'right', color: '#555', whiteSpace: 'nowrap' }}>R$ {it.precoUnitario.toFixed(2)}</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', color: '#333', fontWeight: 500, whiteSpace: 'nowrap' }}>R$ {it.subtotal.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Total */}
            <div style={{ background: '#e8f5e9', borderRadius: 8, padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, border: '1px solid #c8e6c9' }}>
              <span style={{ fontSize: 16, fontWeight: 700, color: '#1b5e20' }}>Valor Final Total:</span>
              <span style={{ fontSize: 22, fontWeight: 800, color: '#2e7d32' }}>R$ {totalPopupPagamento.toFixed(2)}</span>
            </div>

            {/* Aviso auto-save */}
            <p style={{ color: '#e65100', fontSize: 12, textAlign: 'center', marginBottom: 20, background: '#fff3e0', padding: '8px 12px', borderRadius: 6, border: '1px solid #ffe0b2', lineHeight: 1.5 }}>
              ℹ️ Alterações não salvas serão salvas automaticamente antes de redirecionar ao Stripe.
            </p>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <button
                onClick={() => setShowPopupPagamento(false)}
                style={{ padding: '11px 26px', borderRadius: 8, border: 'none', background: '#6c757d', color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer' }}
              >
                Cancelar
              </button>
              <button
                onClick={handleConfirmarEPagar}
                style={{ padding: '11px 26px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #635bff 0%, #7c3aed 100%)', color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 12px rgba(99,91,255,0.4)' }}
              >
                ✅ Confirmar Realizar Pagamento
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== POPUP COMPARTILHAR LINK DE PAGAMENTO ===== */}
      {showPopupCompartilharPagamento && (
        <div
          onClick={() => setShowPopupCompartilharPagamento(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 16, padding: '32px 28px', maxWidth: 440, width: '92%', boxShadow: '0 8px 32px rgba(0,0,0,0.25)', position: 'relative' }}
          >
            <button
              onClick={() => setShowPopupCompartilharPagamento(false)}
              style={{ position: 'absolute', top: 14, right: 14, width: 32, height: 32, borderRadius: '50%', border: 'none', background: '#ff9800', color: '#fff', fontSize: 18, fontWeight: 700, cursor: 'pointer', lineHeight: '32px', textAlign: 'center', padding: 0 }}
            >
              ×
            </button>

            <h3 style={{ margin: '0 0 8px', color: '#1a237e', fontSize: 20 }}>Compartilhar Link de Pagamento</h3>
            <p style={{ color: '#555', marginBottom: 20, fontSize: 14, lineHeight: 1.5 }}>
              O link de pagamento foi gerado com sucesso. Copie o link, envie por WhatsApp ou por e-mail para o cliente.
            </p>

            <div style={{ background: '#f5f5f5', border: '1px solid #e0e0e0', borderRadius: 8, padding: '10px 12px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ flex: 1, fontFamily: 'monospace', fontSize: 12, color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {linkPagamentoGerado}
              </span>
              <button
                onClick={handleCopiarLinkPagamento}
                style={{ padding: '6px 14px', borderRadius: 6, border: 'none', background: linkPagamentoCopiado ? '#2e7d32' : '#635bff', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}
              >
                {linkPagamentoCopiado ? '✓ Copiado!' : 'Copiar'}
              </button>
            </div>

            <div style={{ display: 'flex', gap: 20, justifyContent: 'center' }}>
              <button
                onClick={handleCompartilharWhatsAppPagamento}
                title="Compartilhar via WhatsApp"
                style={{ width: 72, height: 72, borderRadius: '50%', border: 'none', background: '#25D366', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <svg viewBox="0 0 24 24" width="34" height="34" fill="#fff">
                  <path d="M12.04 2c-5.52 0-10 4.48-10 10 0 1.77.46 3.45 1.27 4.9L2 22l5.25-1.38A9.94 9.94 0 0012.04 22c5.52 0 10-4.48 10-10s-4.48-10-10-10zm0 18.15c-1.6 0-3.13-.43-4.45-1.24l-.32-.19-3.12.82.83-3.04-.2-.31A8.14 8.14 0 013.9 12c0-4.5 3.66-8.15 8.15-8.15 4.5 0 8.15 3.66 8.15 8.15 0 4.5-3.66 8.15-8.16 8.15zm4.47-6.1c-.24-.12-1.44-.71-1.66-.79-.22-.08-.39-.12-.55.12-.16.24-.63.79-.78.95-.14.16-.29.18-.53.06-.24-.12-1.02-.38-1.94-1.2-.72-.64-1.2-1.43-1.35-1.67-.14-.24-.02-.37.11-.49.11-.11.24-.29.36-.43.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.55-1.33-.76-1.82-.2-.48-.4-.42-.55-.42-.14-.01-.3-.01-.46-.01-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.7 2.6 4.12 3.64.58.25 1.03.4 1.38.51.58.18 1.11.16 1.53.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.46-.28z"/>
                </svg>
              </button>
              <button
                onClick={handleEnviarEmailSMTPPagamento}
                disabled={emailEnviandoPagamento}
                title="Enviar por e-mail"
                style={{ width: 72, height: 72, borderRadius: '50%', border: 'none', background: '#1976d2', cursor: emailEnviandoPagamento ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: emailEnviandoPagamento ? 0.7 : 1 }}
              >
                {emailEnviandoPagamento ? (
                  <span style={{ fontSize: 28 }}>⏳</span>
                ) : (
                  <svg viewBox="0 0 24 24" width="32" height="32" fill="#fff">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== POPUP STATUS ENVIO EMAIL PAGAMENTO ===== */}
      {statusPopupPagamento && (
        <div
          onClick={() => setStatusPopupPagamento(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100000 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 16, padding: '32px 28px', maxWidth: 400, width: '90%', boxShadow: '0 8px 32px rgba(0,0,0,0.3)', textAlign: 'center' }}
          >
            <div style={{ fontSize: 44, marginBottom: 12 }}>
              {statusPopupPagamento.type === 'success' ? '✅' : '❌'}
            </div>
            <h3 style={{ margin: '0 0 12px', color: statusPopupPagamento.type === 'success' ? '#2e7d32' : '#c62828', fontSize: 19 }}>
              {statusPopupPagamento.title}
            </h3>
            {statusPopupPagamento.email ? (
              <div style={{ background: '#e8f5e9', border: '1px solid #c8e6c9', borderRadius: 8, padding: '10px 14px', marginBottom: 12, color: '#2e7d32', fontWeight: 600, fontSize: 14, wordBreak: 'break-all' }}>
                {statusPopupPagamento.email}
              </div>
            ) : null}
            <p style={{ color: '#555', fontSize: 14, lineHeight: 1.5, marginBottom: 20 }}>
              {statusPopupPagamento.text}
            </p>
            <button
              onClick={() => setStatusPopupPagamento(null)}
              style={{ padding: '10px 28px', borderRadius: 8, border: 'none', background: '#635bff', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}

      {/* ===== POPUP CONFIRMAÇÃO CANCELAMENTO ===== */}
      {popupCancelarVenda && (
        <div
          onClick={() => !cancelandoVenda && setPopupCancelarVenda(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 12, padding: '32px 28px', maxWidth: 420, width: '90%', boxShadow: '0 8px 32px rgba(0,0,0,0.25)' }}
          >
            <div style={{ fontSize: 40, textAlign: 'center', marginBottom: 12 }}>⚠️</div>
            <h3 style={{ margin: '0 0 12px', color: '#d32f2f', textAlign: 'center', fontSize: 20 }}>Cancelar Venda</h3>
            <p style={{ color: '#444', textAlign: 'center', marginBottom: 24, lineHeight: 1.5 }}>
              Tem certeza que deseja cancelar a venda <strong>#{vendaEdicao?.id}</strong>? Esta ação não pode ser desfeita.
            </p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <button
                onClick={() => setPopupCancelarVenda(false)}
                disabled={cancelandoVenda}
                style={{ padding: '10px 24px', borderRadius: 8, border: 'none', background: '#6c757d', color: '#fff', fontSize: 15, fontWeight: 600, cursor: cancelandoVenda ? 'not-allowed' : 'pointer' }}
              >
                Voltar
              </button>
              <button
                onClick={handleConfirmarCancelamento}
                disabled={cancelandoVenda}
                style={{ padding: '10px 24px', borderRadius: 8, border: 'none', background: cancelandoVenda ? '#aaa' : '#d32f2f', color: '#fff', fontSize: 15, fontWeight: 600, cursor: cancelandoVenda ? 'not-allowed' : 'pointer' }}
              >
                {cancelandoVenda ? 'Cancelando...' : 'Confirmar Cancelamento'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
